import type { Dictionary } from "./dictionary";

export const CORE_STRINGS: Dictionary = {
  "sidebar.group.masterData": { de: "Stammdaten", en: "Master data" },
  "sidebar.group.settings": { de: "Einstellungen", en: "Settings" },
  "sidebar.group.quality": { de: "Qualitätssicherung", en: "Quality assurance" },
  "sidebar.group.platform": { de: "Plattform", en: "Platform" },
  "sidebar.open": { de: "Menü öffnen", en: "Open menu" },
  "sidebar.close": { de: "Menü schließen", en: "Close menu" },
  "sidebar.expand": { de: "Seitenleiste ausklappen", en: "Expand sidebar" },
  "sidebar.collapse": { de: "Seitenleiste einklappen", en: "Collapse sidebar" },
  "settingsEmail.tab.address": { de: "Adresse", en: "Address" },
  "settingsEmail.tab.forwarding": { de: "Weiterleitung", en: "Forwarding" },
  "settingsEmail.tab.domain": { de: "Domain", en: "Domain" },
  "settingsEmail.tab.mailbox": { de: "Postfach", en: "Mailbox" },
  "settingsEmail.overview": { de: "Übersicht", en: "Overview" },
  "settings.section.ruleValues": { de: "Regelwerte", en: "Rule values" },
  "ruleValues.hint": { de: "Passen Sie die freigegebenen Werte für Ihren Betrieb an. Die Plattform legt fest, welche Werte Sie ändern dürfen und in welchem Bereich.", en: "Adjust the delegated values for your business. The platform sets which values you can change and their permitted ranges." },
  "ruleValues.editable": { de: "Von Ihnen änderbar", en: "You can edit" },
  "ruleValues.unavailable.title": { de: "Regelwerte derzeit nicht bearbeitbar", en: "Rule values cannot currently be edited" },
  "ruleValues.unavailable.body": { de: "Die Bearbeitung ist für diesen Betrieb nicht verfügbar. Die wirksamen Werte finden Sie in der Regelreferenz.", en: "Editing is unavailable for this business. You can find its effective values in the rule reference." },
  "ruleValues.delegationConflict": { de: "Die Plattform hat Ihre Freigaben geändert. Laden Sie die aktuellen Werte und Freigaben, bevor Sie weiterarbeiten.", en: "The platform changed your editing permissions. Load the current values and delegation before continuing." },
  "ruleValues.issue.notDelegated": { de: "Dieser Wert ist nicht mehr zur Bearbeitung freigegeben. Laden Sie die aktuellen Werte.", en: "This value is no longer delegated. Load the current values." },
  "ruleValues.issue.range": { de: "Der Wert liegt außerhalb des freigegebenen Bereichs.", en: "The value is outside the delegated range." },
  "ruleValues.issue.step": { de: "Der Wert muss zur angegebenen Schrittweite passen, ausgehend vom Minimum.", en: "The value must match the specified step, starting at the minimum." },
  "ruleValues.unsaved": { de: "{count} nicht gespeicherte Änderungen", en: "{count} unsaved changes" },
  "ruleValues.checkSave": { de: "Prüfen und speichern", en: "Review and save" },
  "ruleValues.preview.title": { de: "Änderungen prüfen", en: "Review changes" },
  "ruleValues.preview.impact": { de: "Vergleich mit bisherigen Anfragen", en: "Comparison with previous requests" },
  "ruleValues.preview.method": { de: "Stichprobe: {count} der letzten bis zu {limit} Anfragen. Verglichen werden nur Schwellen mit den aktuell gespeicherten Fakten, keine vollständigen Entscheidungen. Zählungen verschiedener Werte können dieselbe Anfrage enthalten.", en: "Sample: {count} of up to {limit} recent requests. Only thresholds are compared against currently stored facts, not complete decisions. Counts for different values may include the same request." },
  "ruleValues.preview.computed": { de: "Berechnet", en: "Computed" },
  "ruleValues.preview.partial": { de: "Teilweise berechnet", en: "Partially computed" },
  "ruleValues.preview.unavailable": { de: "Nicht verfügbar", en: "Unavailable" },
  "ruleValues.preview.not_a_threshold": { de: "Für diesen Ja/Nein-Wert gibt es keinen Schwellenvergleich.", en: "There is no threshold comparison for this yes/no value." },
  "ruleValues.preview.no_comparable_stored_facts": { de: "Keine vergleichbaren gespeicherten Fakten vorhanden.", en: "No comparable stored facts are available." },
  "ruleValues.preview.crossings": { de: "{changed} Anfragen wechseln die Seite der Schwelle: {up} von darunter zu mindestens dem Wert, {down} in die Gegenrichtung.", en: "{changed} requests cross the threshold: {up} from below to at or above it, {down} in the opposite direction." },
  "ruleValues.preview.sample": { de: "{comparable} vergleichbar · {unavailable} ohne ausreichende Daten · {inapplicable} nicht anwendbar", en: "{comparable} comparable · {unavailable} without sufficient data · {inapplicable} not applicable" },
  "ruleValues.preview.customerText": { de: "Mögliche Kundentexte", en: "Possible customer text" },
  "ruleValues.preview.conditional": { de: "Diese deutschen Hinweise erscheinen nur, wenn die jeweilige Regel zutrifft. Sie sind keine vollständige Antwort.", en: "These German notices appear only when the corresponding rule applies. They are not a complete reply." },
  "ruleValues.preview.noText": { de: "Kein eigener Schwellenhinweis vorhanden.", en: "No dedicated threshold notice is available." },
  "ruleValues.sentence.minWrittenOfferGuests.before": { de: "Ab", en: "From" },
  "ruleValues.sentence.minWrittenOfferGuests.after": { de: "Gästen erstellen wir ein individuelles schriftliches Angebot, sofern die weiteren Voraussetzungen erfüllt sind.", en: "guests we prepare an individual written offer, subject to the remaining requirements." },
  "ruleValues.sentence.bbqOnlineShopMinGuests.before": { de: "Ab", en: "From" },
  "ruleValues.sentence.bbqOnlineShopMinGuests.after": { de: "Gästen ist BBQ über den Onlineshop möglich; weitere Voraussetzungen gelten.", en: "guests BBQ is available through the online shop, subject to the remaining requirements." },
  "ruleValues.sentence.bbqPaidServiceMinGuests.before": { de: "Ab", en: "From" },
  "ruleValues.sentence.bbqPaidServiceMinGuests.after": { de: "Gästen ist ein bezahlter BBQ-Service optional möglich; weitere Voraussetzungen gelten.", en: "guests optional paid BBQ service is available, subject to the remaining requirements." },
  "ruleValues.sentence.weekdayFoodMinimumNetCents.before": { de: "Für eine Lieferung Mo–Sa beträgt der Speisenmindestwert", en: "For Mon–Sat delivery the food minimum is" },
  "ruleValues.sentence.weekdayFoodMinimumNetCents.after": { de: "EUR netto; Hamburger Feiertage sind ausgenommen.", en: "EUR net, excluding Hamburg public holidays." },
  "ruleValues.sentence.sundayHolidayFoodMinimumNetCents.before": { de: "Für Sonntag und Hamburger Feiertage beträgt der Speisenmindestwert", en: "For Sundays and Hamburg public holidays the food minimum is" },
  "ruleValues.sentence.sundayHolidayFoodMinimumNetCents.after": { de: "EUR netto; darunter ist Rücksprache erforderlich.", en: "EUR net; below it, consultation is required." },
  "ruleValues.sentence.extrasFoodMinimumNetCents.before": { de: "Getränke, Personal und Ausstattung sind ab einem Speisenwert von", en: "Drinks, staff and equipment are available from a food value of" },
  "ruleValues.sentence.extrasFoodMinimumNetCents.after": { de: "EUR netto möglich; weitere Voraussetzungen gelten.", en: "EUR net, subject to the remaining requirements." },
  "ruleValues.sentence.budgetMandatory.before": { de: "Ein nutzbares Gesamtbudget ist im Bereich schriftlicher Angebote erforderlich:", en: "A usable total budget is required in the written-offer band:" },
  "ruleValues.sentence.budgetMandatory.after": { de: ".", en: "." },
  "ruleValues.sentence.fieldGroupsCombined.before": { de: "Zusammengehörige Angaben zu Datumsbereich und Messestandort gemeinsam erfragen:", en: "Ask related date-range and trade-fair location fields together:" },
  "ruleValues.sentence.fieldGroupsCombined.after": { de: ".", en: "." },

  "mailboxRefresh.action": { de: "Aktualisieren", en: "Refresh" },
  "mailboxRefresh.queued": { de: "Postfachprüfung wartet…", en: "Mailbox check is queued…" },
  "mailboxRefresh.running": { de: "Postfächer werden geprüft…", en: "Checking mailboxes…" },
  "mailboxRefresh.empty": { de: "Postfächer geprüft. Keine neuen E-Mails.", en: "Mailboxes checked. No new mail." },
  "mailboxRefresh.completed": { de: "Postfächer geprüft. Neue E-Mails: {n}.", en: "Mailboxes checked. New messages: {n}." },
  "mailboxRefresh.partial": { de: "Prüfung unvollständig. Neue E-Mails: {n}. Bitte später erneut versuchen.", en: "Check incomplete. New messages: {n}. Please try again later." },
  "mailboxRefresh.failed": { de: "Postfachprüfung fehlgeschlagen. Bitte erneut versuchen.", en: "Mailbox check failed. Please try again." },
  "mailboxRefresh.interrupted": { de: "Prüfung unterbrochen. Bitte erneut versuchen.", en: "Check interrupted. Please try again." },
  "mailboxRefresh.statusError": { de: "Prüfstatus nicht erreichbar. Mit Aktualisieren erneut abrufen.", en: "Check status unavailable. Refresh to check again." },
  "mailboxRefresh.disabled": { de: "E-Mail-Empfang ist deaktiviert.", en: "Mail receiving is disabled." },
  "mailboxRefresh.unavailable": { de: "Postfachprüfung derzeit nicht verfügbar. Bitte später erneut versuchen.", en: "Mailbox check is currently unavailable. Please try again later." },
  "mailboxRefresh.noMailbox": { de: "Kein aktives Empfangspostfach verbunden.", en: "No enabled receiving mailbox is connected." },
  "mailboxRefresh.noContext": { de: "Zuerst einen Betrieb auswählen.", en: "Select a business first." },
  "mailboxRefresh.inactive": { de: "Dieser Betrieb ist schreibgeschützt.", en: "This business is read-only." },
  // ---- common ----
  "common.loading": { de: "Lade…", en: "Loading…" },
  "common.saving": { de: "Speichere…", en: "Saving…" },
  "common.cancel": { de: "Abbrechen", en: "Cancel" },
  "common.close": { de: "Schließen", en: "Close" },
  "common.run": { de: "Ausführen", en: "Run" },
  "common.retry": { de: "Erneut versuchen", en: "Try again" },
  "common.none": { de: "Keine", en: "None" },
  "common.notSet": { de: "Nicht gesetzt", en: "Not set" },
  "common.noInfo": { de: "Keine Angabe", en: "No data" },
  "common.yes": { de: "Ja", en: "Yes" },
  "common.no": { de: "Nein", en: "No" },
  "common.error": { de: "Fehler", en: "Error" },
  "common.back": { de: "Zurück", en: "Back" },
  "common.remove": { de: "Entfernen", en: "Remove" },
  "common.noSubject": { de: "(kein Betreff)", en: "(no subject)" },
  "common.ageMinutes": { de: "{n} Min.", en: "{n} min" },
  "common.ageHours": { de: "{n} Std.", en: "{n} h" },
  "common.ageDays": { de: "{n} T.", en: "{n} d" },

  // ---- design-system accessible names (#890) ----
  // Names only assistive technology reads. They have no visible form to look wrong, so they
  // are the ones that stay in one language after everything else has switched.
  "ds.breadcrumbLabel": { de: "Brotkrumen", en: "Breadcrumb" },
  "ds.switch.on": { de: "AN", en: "ON" },
  "ds.switch.off": { de: "AUS", en: "OFF" },
  "ds.table.selectAll": { de: "Alle auswählen", en: "Select all" },
  "ds.table.selectRow": { de: "Zeile auswählen", en: "Select row" },
  "ds.field.optional": { de: "(optional)", en: "(optional)" },

  // ---- app shell ----
  "shell.groupCockpit": { de: "Cockpit", en: "Cockpit" },
  "shell.groupSystem": { de: "System", en: "System" },
  "shell.overview": { de: "Übersicht", en: "Overview" },
  "shell.navAria": { de: "Hauptnavigation", en: "Main navigation" },
  "shell.more": { de: "Mehr", en: "More" },
  "shell.moreMenu": { de: "Weitere Bereiche", en: "More destinations" },
  "shell.moreEmpty": { de: "Keine weiteren Bereiche verfügbar", en: "No more destinations available" },
  "shell.themeLight": { de: "Auf helles Design umschalten", en: "Switch to light theme" },
  "shell.themeDark": { de: "Auf dunkles Design umschalten", en: "Switch to dark theme" },
  "shell.account": { de: "Konto", en: "Account" },
  "sidebar.darkTheme": { de: "Dunkles Design", en: "Dark theme" },
  "shell.accountMenu": { de: "Benutzermenü", en: "Account menu" },
  "shell.settings": { de: "Einstellungen", en: "Settings" },
  "ruleReference.shellTitle": { de: "Regelreferenz", en: "Rule reference" },
  "shell.staff": { de: "Personal", en: "Staff" },
  "shell.rules": { de: "Regeln", en: "Rules" },
  "shell.logout": { de: "Abmelden", en: "Sign out" },
  "shell.aiExtraction": { de: "KI-Extraktion", en: "AI extraction" },
  "shell.active": { de: "aktiv", en: "active" },
  "shell.off": { de: "aus", en: "off" },
  "shell.dispatch": { de: "Versand", en: "Sending" },
  "shell.free": { de: "frei", en: "enabled" },
  "shell.locked": { de: "gesperrt", en: "locked" },
  "shell.devEnvironment": { de: "DEV · Testumgebung, nicht das Live-System", en: "DEV · Test environment, not the live system" },
  "shell.devEnvironmentShort": { de: "DEV", en: "DEV" },
  "shell.aiBannerTitle": { de: "KI-Extraktion deaktiviert", en: "AI extraction disabled" },
  "shell.aiBannerBody": {
    de: "Die KI-gestützte Extraktion und Formulierung ist derzeit ausgeschaltet (AI_ENABLED=false). Neue Anfragen werden nicht automatisch ausgewertet; Entwürfe können nicht generiert werden.",
    en: "AI-assisted extraction and composition is currently switched off (AI_ENABLED=false). New requests are not evaluated automatically and drafts cannot be generated.",
  },
  "shell.businesses": { de: "Betriebe", en: "Businesses" },
  "shell.noBusinessTitle": { de: "Kein Betrieb ausgewählt", en: "No business selected" },
  "shell.noBusinessBody": {
    de: "Als Inhaber sehen Sie Betriebsdaten nur mit ausgewähltem Betrieb. Öffnen Sie die Betriebsverwaltung und wählen Sie dort einen Betrieb.",
    en: "As the owner you only see business data with a business selected. Open the businesses panel and pick one there.",
  },
  "shell.noBusinessCta": { de: "Betriebe verwalten", en: "Manage businesses" },
  "shell.tenantSuspendedTitle": { de: "Konto ausgesetzt – nur Lesezugriff", en: "Account suspended — read-only" },
  "shell.tenantSuspendedBody": {
    de: "Dieses Geschäftskonto wurde vom Inhaber ausgesetzt. Alle Daten bleiben sichtbar, aber Änderungen, Entwürfe und Versand sind gesperrt.",
    en: "This business account has been suspended by the owner. All data stays visible, but changes, drafts and sending are blocked.",
  },
  "shell.tenantArchivedTitle": { de: "Konto archiviert – nur Lesezugriff", en: "Account archived — read-only" },
  "shell.tenantArchivedBody": {
    de: "Dieses Geschäftskonto ist archiviert. Alle Daten bleiben sichtbar, aber Änderungen, Entwürfe und Versand sind dauerhaft gesperrt.",
    en: "This business account is archived. All data stays visible, but changes, drafts and sending are permanently blocked.",
  },
  "businesses.title": { de: "Betriebe", en: "Businesses" },
  "businesses.sub": { de: "Betriebe anlegen, aussetzen und deren Nutzung einsehen — nur für Inhaber sichtbar.", en: "Create and suspend businesses and inspect their usage — visible to owners only." },
  "businesses.list": { de: "Alle Betriebe", en: "All businesses" },
  "businesses.colName": { de: "Name", en: "Name" },
  "businesses.colSlug": { de: "Kürzel", en: "Slug" },
  "businesses.colStatus": { de: "Status", en: "Status" },
  "businesses.colCreated": { de: "Angelegt", en: "Created" },
  "businesses.colAction": { de: "Aktion", en: "Action" },
  "businesses.status.active": { de: "Aktiv", en: "Active" },
  "businesses.status.suspended": { de: "Ausgesetzt", en: "Suspended" },
  "businesses.status.archived": { de: "Archiviert", en: "Archived" },
  "businesses.browsing": { de: "Aktuell ausgewählt", en: "Currently selected" },
  "businesses.browse": { de: "Öffnen", en: "Browse" },
  "businesses.usage": { de: "Nutzung", en: "Usage" },
  "businesses.suspend": { de: "Aussetzen", en: "Suspend" },
  "businesses.resume": { de: "Fortsetzen", en: "Resume" },
  "businesses.archive": { de: "Archivieren", en: "Archive" },
  "businesses.none": { de: "Noch keine Betriebe.", en: "No businesses yet." },
  "businesses.create": { de: "Neuen Betrieb anlegen", en: "Create a new business" },
  "businesses.createBtn": { de: "Betrieb anlegen", en: "Create business" },
  "businesses.slugRule": {
    de: "Kürzel: nur Kleinbuchstaben, Ziffern und Bindestriche; beginnt mit Buchstabe/Ziffer; max. 63 Zeichen.",
    en: "Slug: lowercase letters, digits and hyphens only; starts alphanumeric; max 63 characters.",
  },
  "businesses.created": { de: "Betrieb angelegt", en: "Business created" },
  // #780: preparing a business for its future owner rather than starting to run it.
  "businesses.prepared": {
    de: "Betrieb für den Inhaber vorbereiten",
    en: "Prepare this business for its owner",
  },
  "businesses.preparedHint": {
    de: "Der Betrieb wird angelegt, bleibt aber inaktiv. Sie erzeugen anschließend einen Übergabe-Link; der Inhaber vervollständigt die Daten, wählt seine E-Mail-Adresse und schaltet den Betrieb damit frei.",
    en: "The business is created but stays inactive. You then create a handover link; the owner completes the details, picks their address, and activates it.",
  },
  "businesses.preparedCreated": {
    de: "Inaktiv angelegt. Erzeugen Sie jetzt den Übergabe-Link für den Inhaber.",
    en: "Created inactive. Create the handover link for the owner next.",
  },
  "businesses.suspended": { de: "Betrieb ausgesetzt", en: "Business suspended" },
  "businesses.resumed": { de: "Betrieb fortgesetzt", en: "Business resumed" },
  "businesses.archived": { de: "Betrieb archiviert", en: "Business archived" },
  "businesses.archiveTitle": { de: "Betrieb archivieren?", en: "Archive business?" },
  "businesses.archiving": { de: "Archiviere…", en: "Archiving…" },
  "businesses.archiveConfirm": {
    de: "Der Betrieb wird dauerhaft stillgelegt: kein Mailempfang, kein Versand, nur Lesezugriff.",
    en: "The business is permanently decommissioned: no mail intake, no sending, read-only access.",
  },
  "businesses.archiveIrreversible": {
    de: "Dieser Schritt kann nicht rückgängig gemacht werden.",
    en: "This step cannot be undone.",
  },
  "businesses.usageTitle": { de: "Nutzung", en: "Usage" },
  "businesses.usageRequests": { de: "Anfragen", en: "Requests" },
  "businesses.usageOpen": { de: "offen", en: "open" },
  "businesses.usageMessages": { de: "Nachrichten", en: "Messages" },
  "businesses.usageInbound": { de: "eingehend", en: "inbound" },
  "businesses.usageUsers": { de: "Benutzer", en: "Users" },
  "businesses.usageSends": { de: "Sendeversuche", en: "Send attempts" },
  "businesses.usageLlm": { de: "KI-Aufrufe", en: "AI calls" },
  "businesses.usageLast30d": { de: "letzte 30 Tage", en: "last 30 days" },
  "businesses.readiness.action": { de: "Bereitschaft", en: "Readiness" },
  "businesses.readiness.title": { de: "Bereitschaft", en: "Readiness" },
  "businesses.readiness.overall": { de: "Gesamtstatus", en: "Overall" },
  "businesses.readiness.ready": { de: "Bereit", en: "Ready" },
  "businesses.readiness.notReady": { de: "Nicht bereit", en: "Not ready" },
  "businesses.readiness.parameters": { de: "Fester Regelsatz", en: "Fixed ruleset" },
  "businesses.readiness.policy": { de: "Laufzeitquelle", en: "Runtime source" },
  "businesses.readiness.policyVersion": { de: "Aktive Policy-Version", en: "Active policy version" },
  "businesses.readiness.boundary": { de: "Master-Grenze", en: "Master boundary" },
  "businesses.readiness.boundaryWarn": { de: "Policy außerhalb der Grenze – neu veröffentlichen", en: "Policy out of boundary – republish" },
  "businesses.readiness.status.healthy": { de: "In Ordnung", en: "Healthy" },
  "businesses.readiness.status.unhealthy": { de: "Gestört", en: "Unhealthy" },

  // Per-tenant catalog import (#263)
  "businesses.catalog.action": { de: "Katalog", en: "Catalog" },
  "businesses.catalog.title": { de: "Katalog (BankettProfi-Import)", en: "Catalog (BankettProfi import)" },
  "businesses.catalog.active": { de: "Aktive Artikel", en: "Active articles" },
  "businesses.catalog.packages": { de: "Aktive Pakete", en: "Active packages" },
  "businesses.catalog.lastImport": { de: "Letzter Import", en: "Last import" },
  "businesses.catalog.never": { de: "Noch nie", en: "Never" },
  "businesses.catalog.upload": { de: "Artikel.csv oder Artikelliste.xlsx importieren", en: "Import Artikel.csv or Artikelliste.xlsx" },
  "businesses.catalog.fileLabel": { de: "Katalogdatei", en: "Catalog file" },
  "businesses.catalog.hint": { de: "Kompletter BankettProfi-Export (Artikel.csv oder Artikelliste.xlsx). Bei XLSX werden Artikel ohne positiven Verkaufspreis sowie Rezeptur- und Packlistenartikel ausgeschlossen. Der Import ersetzt den importierten Katalog dieses Betriebs; fehlende und ausgeschlossene Artikel werden deaktiviert. Selbst angelegte Artikel bleiben erhalten. Es wird nichts zu BankettProfi exportiert.", en: "Full BankettProfi export (Artikel.csv or Artikelliste.xlsx). For XLSX, articles without a positive sale price plus recipe and packing-list articles are excluded. The import replaces this business's imported catalog; missing and excluded articles are deactivated. Articles added by hand are kept. Nothing is ever exported to BankettProfi." },
  "businesses.catalog.import": { de: "Importieren", en: "Import" },
  "businesses.catalog.importing": { de: "Importiere…", en: "Importing…" },
  "businesses.catalog.imported": { de: "Katalog importiert.", en: "Catalog imported." },
  "businesses.catalog.summary": { de: "{imported} Artikel importiert ({packages} Pakete), {skipped} übersprungen, {deactivated} deaktiviert.", en: "{imported} articles imported ({packages} packages), {skipped} skipped, {deactivated} deactivated." },
  "businesses.catalog.skipBreakdown": { de: "Gründe: {noPrice} ohne positiven Preis, {internal} interne Artikel, {invalid} ungültige Zeilen.", en: "Reasons: {noPrice} without a positive price, {internal} internal articles, {invalid} invalid rows." },
  "businesses.catalog.replaceTitle": { de: "Katalog ersetzen?", en: "Replace catalog?" },
  "businesses.catalog.replaceWarn": { de: "Dieser Betrieb hat bereits {count} aktive Artikel. Der Import ersetzt den Katalog. Bei XLSX werden fehlende Artikel sowie Artikel ohne positiven Verkaufspreis und Rezeptur- oder Packlistenartikel deaktiviert. Selbst angelegte Artikel bleiben erhalten.", en: "This business already has {count} active articles. The import replaces the catalog. For XLSX, missing articles, articles without a positive sale price, and recipe or packing-list articles are deactivated. Articles added by hand are kept." },
  "businesses.catalog.replaceConfirm": { de: "Ja, Katalog ersetzen", en: "Yes, replace catalog" },
  "businesses.catalog.errEmpty": { de: "Die Datei ist leer.", en: "The file is empty." },
  "businesses.catalog.errTooLarge": { de: "Die Datei ist zu groß (max. 2 MB).", en: "The file is too large (max 2 MB)." },
  "businesses.catalog.errNotCatalogFile": { de: "Bitte eine .csv- oder .xlsx-Datei wählen.", en: "Please choose a .csv or .xlsx file." },

  // Catalog article listing with search (#382)
  "businesses.catalog.articles": { de: "Positionen", en: "Articles" },
  "businesses.catalog.resultsLabel": { de: "Katalogergebnisse", en: "Catalog results" },
  "businesses.catalog.loadingResults": { de: "Katalogpositionen werden geladen…", en: "Loading catalog articles…" },
  "businesses.catalog.updatingResults": { de: "Katalogergebnisse werden aktualisiert…", en: "Updating catalog results…" },
  "businesses.catalog.searchPlaceholder": { de: "Positionen durchsuchen…", en: "Search articles…" },
  "businesses.catalog.matchCount": { de: "{count} Positionen", en: "{count} articles" },
  "businesses.catalog.emptyCatalog": { de: "Noch keine Positionen – unten einen Katalog importieren.", en: "No articles yet – import a catalog below." },
  "businesses.catalog.noResults": { de: "Keine Treffer für diese Suche.", en: "No matches for this search." },
  "businesses.catalog.colBpId": { de: "BP-Nr", en: "BP id" },
  "businesses.catalog.colName": { de: "Name", en: "Name" },
  "businesses.catalog.colGroup": { de: "Gruppe", en: "Group" },
  "businesses.catalog.colPrice": { de: "Preis (netto)", en: "Price (net)" },
  "businesses.catalog.priceShort": { de: "Netto", en: "Net" },
  "businesses.catalog.availability": { de: "Verfügbarkeit", en: "Availability" },
  "businesses.catalog.characteristics": { de: "Merkmale", en: "Characteristics" },
  "businesses.catalog.goToImport": { de: "Zum Import", en: "Go to import" },
  "businesses.catalog.flagActive": { de: "Aktiv", en: "Active" },
  "businesses.catalog.flagInactive": { de: "Inaktiv", en: "Inactive" },
  "businesses.catalog.flagPackage": { de: "Paket", en: "Package" },
  "businesses.catalog.flagVegan": { de: "Vegan", en: "Vegan" },
  "businesses.catalog.flagVegetarian": { de: "Vegetarisch", en: "Vegetarian" },
  "businesses.catalog.pagePrev": { de: "Zurück", en: "Previous" },
  "businesses.catalog.pageNext": { de: "Weiter", en: "Next" },
  "businesses.catalog.pageRange": { de: "{from}–{to} von {total}", en: "{from}–{to} of {total}" },

  // Owner mailbox provisioning (#236)
  "businesses.mailboxes": { de: "Postfächer", en: "Mailboxes" },
  "businesses.sendPaused": { de: "Versand pausiert", en: "Sending paused" },
  "businesses.sendPause": { de: "Versand pausieren", en: "Pause sending" },
  "businesses.sendResume": { de: "Versand fortsetzen", en: "Resume sending" },
  "businesses.sendPausedToast": { de: "Versand pausiert.", en: "Sending paused." },
  "businesses.sendResumedToast": { de: "Versand fortgesetzt.", en: "Sending resumed." },

  // Per-tenant feature/quota model (#239)
  "businesses.features.action": { de: "Funktionen", en: "Features" },
  "businesses.features.title": { de: "Funktionen & Kontingente", en: "Features & limits" },
  // #1618: bounded per-business values of the code-owned rule parameters (owner plane).
  "businesses.rules.title": { de: "Regelparameter", en: "Rule parameters" },
  "businesses.rules.hint": {
    de: "Die Regeln stehen fest im Code. Hier legen Sie nur die Werte der registrierten Parameter für diesen Betrieb fest; Grenzen und Abhängigkeiten prüft der Server.",
    en: "The rules are fixed in code. Here you only set this business's values for the registered parameters; the server checks bounds and dependencies.",
  },
  "businesses.rules.tab.label": { de: "Regelwerte", en: "Rule values" },
  "businesses.rules.tab.values": { de: "Werte", en: "Values" },
  "businesses.rules.tab.delegation": { de: "Freigaben", en: "Delegation" },
  "businesses.rules.tab.history": { de: "Verlauf", en: "History" },
  "businesses.rules.delegation.hint": {
    de: "Legen Sie fest, welche Werte die Betriebsadministration bearbeiten darf. Freigaben ändern keine Werte, werden aber sofort wirksam: Die Administration kann die freigegebenen Werte gleich nach dem Speichern bearbeiten. Der erlaubte Bereich muss den aktuellen Wert enthalten; Schritte zählen ab dem Minimum.",
    en: "Choose which values business admins may edit. Delegation does not change values, but it takes effect at once: admins can edit the delegated values as soon as you save. The permitted range must include the current value; steps start at the minimum.",
  },
  "businesses.rules.delegation.technical": { de: "Technische Grenzen: {min} bis {max}, Schritt {step}.", en: "Technical limits: {min} to {max}, step {step}." },
  "businesses.rules.delegation.boolean": { de: "Erlaubte Werte: Ja oder Nein; kein Zahlenbereich.", en: "Allowed values: yes or no; no numeric range." },
  "businesses.rules.delegation.min": { de: "Minimum", en: "Minimum" },
  "businesses.rules.delegation.max": { de: "Maximum", en: "Maximum" },
  "businesses.rules.delegation.step": { de: "Schritt", en: "Step" },
  "businesses.rules.delegation.range": { de: "{min}–{max}, Schritt {step}", en: "{min}–{max}, step {step}" },
  "businesses.rules.delegation.version": { de: "Freigaben · Version {version}", en: "Delegation · version {version}" },
  "businesses.rules.delegation.save": { de: "Freigaben speichern", en: "Save delegation" },
  "businesses.rules.delegation.saved": { de: "Freigaben als Version {version} gespeichert", en: "Delegation saved as version {version}" },
  "businesses.rules.delegation.conflict": { de: "Freigaben wurden inzwischen geändert", en: "Delegation changed in the meantime" },
  "businesses.rules.delegation.reload": { de: "Aktuelle Freigaben laden", en: "Load current delegation" },
  "businesses.rules.delegation.issue.invalid_delegation_range": {
    de: "Minimum, Maximum und Schritt müssen ganze Zahlen innerhalb der technischen Grenzen sein. Minimum darf Maximum nicht überschreiten; der Schritt muss zum technischen Schritt passen.",
    en: "Minimum, maximum and step must be whole numbers within the technical limits. Minimum must not exceed maximum; the step must match the technical step.",
  },
  "businesses.rules.delegation.issue.delegation_excludes_active_value": {
    de: "Dieser Bereich oder Schritt schließt den aktuell gespeicherten Wert aus. Passen Sie die Freigabe an oder speichern Sie zuerst einen passenden Wert unter Werte.",
    en: "This range or step excludes the currently saved value. Adjust the delegation or first save a suitable value under Values.",
  },
  "businesses.rules.delegation.issue.invalid_delegation": { de: "Bitte Plattform oder Betrieb wählen.", en: "Choose platform or business." },
  "businesses.rules.delegation.issue.invalid_delegation_fields": { de: "Diese Freigabe enthält unzulässige Felder. Laden Sie die aktuellen Freigaben.", en: "This delegation contains unsupported fields. Load the current delegation." },
  "businesses.rules.history.values": { de: "Werte · V{version}", en: "Values · V{version}" },
  "businesses.rules.history.delegation": { de: "Freigaben · V{version}", en: "Delegation · V{version}" },
  "businesses.rules.source": { de: "Wirksame Werte", en: "Effective values" },
  "businesses.rules.source.defaults": { de: "Code-Standardwerte", en: "Code defaults" },
  "businesses.rules.source.tenantSet": { de: "Werte dieses Betriebs, Version {version}", en: "This business's values, version {version}" },
  "businesses.rules.readOnly.title": { de: "Nur lesbar", en: "Read-only" },
  "businesses.rules.readOnly.body": {
    de: "Ausgesetzte und archivierte Betriebe können nicht bearbeitet werden.",
    en: "Suspended and archived businesses cannot be edited.",
  },
  "businesses.rules.conflict.title": { de: "Werte wurden inzwischen geändert", en: "Values changed in the meantime" },
  "businesses.rules.conflict.body": {
    de: "Inzwischen wurde Version {version} gespeichert. Laden Sie die aktuellen Werte; Ihre ungespeicherten Änderungen werden verworfen.",
    en: "Version {version} was saved in the meantime. Load the current values; your unsaved changes are discarded.",
  },
  "businesses.rules.conflict.reload": { de: "Aktuelle Werte laden", en: "Load current values" },
  "businesses.rules.remote.title": { de: "Gespeicherte Werte oder Berechtigungen haben sich geändert", en: "Saved values or permissions have changed" },
  "businesses.rules.remote.body": {
    de: "Ihre Eingaben bleiben erhalten. Laden Sie vor dem Speichern den aktuellen Stand; dabei werden ungespeicherte Änderungen verworfen.",
    en: "Your input is preserved. Load the current state before saving; this discards unsaved changes.",
  },
  "businesses.rules.remote.reload": { de: "Änderungen verwerfen und neu laden", en: "Discard changes and reload" },
  "businesses.rules.remote.unavailable": {
    de: "Der aktuelle Stand konnte nicht geladen werden. Bitte laden Sie die Werte erneut, bevor Sie speichern.",
    en: "The current state could not be loaded. Reload the values before saving.",
  },
  "businesses.rules.invalid.title": { de: "Nicht gespeichert", en: "Not saved" },
  "businesses.rules.invalid.body": {
    de: "Der Server hat die Werte abgelehnt. Die Gründe stehen an den Feldern.",
    en: "The server rejected the values. The reasons are shown at the fields.",
  },
  "businesses.rules.invalidSet.title": { de: "Gespeicherte Werte ungültig", en: "Stored values invalid" },
  "businesses.rules.invalidSet.body": {
    de: "Der aktive Parametersatz dieses Betriebs besteht die Prüfung des aktuellen Codes nicht mehr. Neue Vorgänge dieses Betriebs werden nicht automatisch entschieden, bis der Code korrigiert ist.",
    en: "This business's active parameter set no longer passes the current code's checks. New requests of this business are not decided automatically until the code is corrected.",
  },
  "businesses.rules.issue.atLeast": { de: "Mindestens {min}.", en: "At least {min}." },
  "businesses.rules.issue.between": { de: "Zwischen {min} und {max}.", en: "Between {min} and {max}." },
  "businesses.rules.issue.tooLarge": { de: "Der Wert ist zu groß.", en: "The value is too large." },
  "businesses.rules.issue.integer": { de: "Bitte eine ganze Zahl eingeben.", en: "Enter a whole number." },
  "businesses.rules.issue.boolean": { de: "Bitte Ja oder Nein wählen.", en: "Choose yes or no." },
  "businesses.rules.issue.invariant": { de: "Die Werte widersprechen einer Abhängigkeit.", en: "The values break a dependency." },
  "businesses.rules.issue.other": { de: "Vom Server abgelehnt ({code}).", en: "Rejected by the server ({code})." },
  "businesses.rules.invariant.ordered_guest_thresholds": {
    de: "Es muss gelten: BBQ im Onlineshop ≤ schriftliches Angebot ≤ bezahlter BBQ-Service.",
    en: "Must hold: online-shop BBQ ≤ written offer ≤ paid BBQ service.",
  },
  "businesses.rules.bounds.atLeast": { de: "mindestens {min}, ohne Obergrenze", en: "at least {min}, no upper bound" },
  "businesses.rules.bounds.between": { de: "{min} bis {max}", en: "{min} to {max}" },
  "businesses.rules.default": { de: "Standard: {value}", en: "Default: {value}" },
  "businesses.rules.yes": { de: "Ja", en: "Yes" },
  "businesses.rules.no": { de: "Nein", en: "No" },
  "businesses.rules.useDefault": { de: "Standardwert übernehmen", en: "Use default" },
  "businesses.rules.risk.medium_high": { de: "Risiko mittel bis hoch", en: "Medium-high risk" },
  "businesses.rules.risk.high": { de: "Hohes Risiko", en: "High risk" },
  "businesses.rules.risk.critical": { de: "Kritisches Risiko", en: "Critical risk" },
  "businesses.rules.param.minWrittenOfferGuests": { de: "Schriftliches Angebot ab (Gäste)", en: "Written offer from (guests)" },
  "businesses.rules.param.bbqOnlineShopMinGuests": { de: "BBQ im Onlineshop ab (Gäste)", en: "Online-shop BBQ from (guests)" },
  "businesses.rules.param.bbqPaidServiceMinGuests": { de: "Bezahlter BBQ-Service ab (Gäste)", en: "Paid BBQ service from (guests)" },
  "businesses.rules.issue.cents": { de: "Bitte einen EUR-Betrag mit höchstens zwei Nachkommastellen eingeben.", en: "Enter a EUR amount with at most two decimal places." },
  "businesses.rules.param.weekdayFoodMinimumNetCents": { de: "Lieferung Mo–Sa ab (EUR netto)", en: "Mon–Sat delivery from (EUR net)" },
  "businesses.rules.param.sundayHolidayFoodMinimumNetCents": { de: "Sonntag/Feiertag ab (EUR netto)", en: "Sunday/public holiday from (EUR net)" },
  "businesses.rules.param.extrasFoodMinimumNetCents": { de: "Zusatzleistungen ab (EUR netto)", en: "Extras from (EUR net)" },
  "businesses.rules.invariant.ordered_food_minimums": { de: "Der Mindestwert für Sonntag/Feiertag muss mindestens dem Wert für Mo–Sa entsprechen.", en: "The Sunday/public-holiday minimum must be at least the Mon–Sat minimum." },
  "ruleReference.commercial.weekday": { de: "Mo–Sa, kein Hamburger Feiertag", en: "Mon–Sat, excluding Hamburg public holidays" },
  "ruleReference.commercial.sunday": { de: "Sonntag/Hamburger Feiertag", en: "Sunday/Hamburg public holiday" },
  "ruleReference.commercial.below": { de: "unter {amount}", en: "below {amount}" },
  "ruleReference.commercial.from": { de: "ab {amount}", en: "from {amount}" },
  "ruleReference.commercial.unknown": { de: "Wert nicht verfügbar", en: "Value unavailable" },
  "ruleReference.commercial.extras": { de: "Getränke, Personal und Equipment benötigen einen autoritativen Speisen-Nettowarenwert ab {amount}. Getränke, Personal und Equipment selbst zählen nicht dazu. Bei ausdrücklich angefragten, gesperrten Extras nennt der Hinweis den am Vorgang gepinnten Mindestwert.", en: "Drinks, staff and equipment require an authoritative net food subtotal of at least {amount}. Drinks, staff and equipment do not count toward it. For explicitly requested but blocked extras, the notice states the request’s pinned minimum." },
  "businesses.rules.param.budgetMandatory": { de: "Budget ist Pflichtangabe", en: "Budget is required" },
  "businesses.rules.param.fieldGroupsCombined": { de: "Zusammengehörige Felder gemeinsam erfragen", en: "Ask related fields together" },
  "businesses.rules.openRequests": {
    de: "Neue Vorgänge verwenden die gespeicherten Werte. Offene Vorgänge behalten die Werte, mit denen sie begonnen haben.",
    en: "New requests use the saved values. Open requests keep the values they started with.",
  },
  "businesses.rules.discard": { de: "Änderungen verwerfen", en: "Discard changes" },
  "businesses.rules.unsaved": { de: "Nicht gespeicherte Änderungen", en: "Unsaved changes" },
  "businesses.rules.restored.title": { de: "Nicht gespeicherte Änderungen wiederhergestellt", en: "Unsaved changes restored" },
  "businesses.rules.restored.body": {
    de: "Diese Werte sind noch nicht gespeichert. Speichern Sie sie oder verwerfen Sie die Änderungen.",
    en: "These values are not saved yet. Save them or discard the changes.",
  },
  "businesses.rules.save": { de: "Speichern", en: "Save" },
  "businesses.rules.saved": { de: "Version {version} gespeichert", en: "Version {version} saved" },
  "businesses.rules.unchanged": {
    de: "Keine Änderung: Diese Werte sind bereits gespeichert",
    en: "No change: these values are already saved",
  },
  "businesses.rules.history": { de: "Verlauf", en: "History" },
  "businesses.rules.historyEmpty": {
    de: "Noch keine Änderungen an Werten oder Freigaben. Dieser Betrieb verwendet die Code-Standardwerte.",
    en: "No value or delegation changes yet. This business uses the code defaults.",
  },
  "businesses.rules.actorSystem": { de: "System", en: "System" },
  "businesses.rules.actorUnavailable": { de: "Benutzer nicht mehr verfügbar", en: "User no longer available" },
  "businesses.rules.plane.platform": { de: "Plattform", en: "Platform" },
  "businesses.rules.plane.business": { de: "Betrieb", en: "Business" },
  "businesses.rules.historyNoChange": { de: "Werte unverändert", en: "Values unchanged" },
  "businesses.rules.version": { de: "Version {version}", en: "Version {version}" },
  "businesses.rules.active": { de: "Aktiv", en: "Active" },
  // #1618: the rule reference shows the viewing business's effective values.
  "ruleReference.parameters.title": { de: "Regelparameter dieses Betriebs", en: "This business's rule parameters" },
  "ruleReference.parameters.note": {
    de: "Neue Vorgänge verwenden diese Werte. Offene Vorgänge behalten die Werte, mit denen sie begonnen haben. Admins können freigegebene Werte unter Einstellungen → Regelwerte ändern; die übrigen Werte legt die Plattform fest.",
    en: "New requests use these values. Open requests keep the values they started with. Admins can change delegated values in Settings → Rule values; the platform sets the remaining values.",
  },
  "ruleReference.parameters.noBusiness": {
    de: "Kein Betrieb geöffnet. Jeder Betrieb kann eigene Werte haben; öffnen Sie einen Betrieb, um seine Werte zu sehen.",
    en: "No business is open. Each business can have its own values; open a business to see its values.",
  },
  "ruleReference.parameters.unavailable": {
    de: "Die Werte dieses Betriebs sind nicht verfügbar.",
    en: "This business's values are unavailable.",
  },
  "businesses.features.hint": {
    de: "Der Eigentümer entscheidet, welche Funktionen dieser Betrieb nutzen darf. Der globale Kill-Switch und der Betriebsstatus stehen darüber (fail-closed).",
    en: "The owner decides which capabilities this business may use. The global kill-switch and the business status sit above these toggles (fail-closed).",
  },
  "businesses.features.colFeature": { de: "Funktion", en: "Feature" },
  "businesses.features.colStatus": { de: "Effektiv", en: "Effective" },
  "businesses.features.colToggle": { de: "Betrieb", en: "Business" },
  "businesses.features.colLimits": { de: "Kontingente", en: "Limits" },
  "businesses.features.colDefault": { de: "Standard", en: "Default" },
  "businesses.features.globalEnv": { de: "Globaler Env-Schalter", en: "Global env switch" },
  "businesses.features.on": { de: "An", en: "On" },
  "businesses.features.off": { de: "Aus", en: "Off" },
  "businesses.features.reset": { de: "Auf Standard zurücksetzen", en: "Reset to default" },
  "businesses.features.inherit": { de: "Standard", en: "Inherit" },
  "businesses.features.reason.env": { de: "global deaktiviert", en: "disabled globally" },
  "businesses.features.reason.suspended": { de: "Betrieb pausiert", en: "business suspended" },
  "businesses.features.reason.disabled": { de: "vom Eigentümer deaktiviert", en: "disabled by owner" },
  "businesses.features.reason.globalQuota": { de: "globales Google-Kontingent erschöpft", en: "global Google quota exhausted" },
  "businesses.features.reason.quota": { de: "Kontingent erschöpft", en: "quota exhausted" },
  "businesses.features.defaultsAction": { de: "Standardwerte", en: "Defaults" },
  "businesses.features.defaultsTitle": { de: "Funktions-Standardwerte", en: "Feature defaults" },
  "businesses.features.businessDefaultsTitle": { de: "Standardwerte für Betriebe", en: "Business defaults" },
  "businesses.features.googleQuotaSaveScope": {
    de: "Gilt für alle Betriebe zusammen und wird separat gespeichert.",
    en: "Applies to all businesses combined and is saved separately.",
  },
  "businesses.features.defaultsHint": {
    de: "Standardwerte gelten für jeden Betrieb ohne eigene Übersteuerung. Die kostenpflichtige Adresssuche wird ausschließlich pro Betrieb aktiviert.",
    en: "Defaults apply to every business without its own override. Paid address lookup is enabled per business only.",
  },
  "businesses.features.saveDefaults": { de: "Standardwerte speichern", en: "Save defaults" },
  "businesses.features.defaultsSaved": { de: "Standardwerte gespeichert.", en: "Defaults saved." },
  "businesses.feature.ingest": { de: "E-Mail-Abruf", en: "Email ingest" },
  "businesses.feature.ai_extraction": { de: "KI-Extraktion", en: "AI extraction" },
  "businesses.feature.draft_compose": { de: "Entwurf erstellen", en: "Draft compose" },
  "businesses.feature.single_agent_workflow": { de: "Sol-Anfrageverarbeitung", en: "Sol enquiry processing" },
  "businesses.feature.single_agent_workflow.hint": {
    de: "Erlaubt Sol für diesen Betrieb. Der Standard für neue Anfragen wird oben separat gewählt. Sol verbraucht KI-Budget; jede Antwort braucht weiterhin Ihre Freigabe.",
    en: "Allows Sol for this business. Choose the new-enquiry default separately above. Sol consumes AI budget; every reply still needs your approval.",
  },
  "businesses.feature.send": { de: "Versand", en: "Sending" },
  "businesses.feature.rule_params_edit": { de: "Regel-Parameter", en: "Rule parameters" },
  "businesses.feature.rule_proposal_ai": { de: "KI-Assistent (Regeln)", en: "NL rule assist" },
  "businesses.feature.external_lookup": { de: "Externe Adresssuche", en: "External lookup" },
  "businesses.feature.positions_offer": { de: "Positions-Angebot", en: "Positions offer" },
  "businesses.feature.rule_values_edit": { de: "Regelwerte bearbeiten", en: "Rule value editing" },
  "businesses.feature.rule_values_edit.hint": {
    de: "Admins dieses Betriebs können die Werte ändern, die unter Regelwerte → Freigaben freigegeben sind.",
    en: "This business's admins can change the values delegated under Rule values → Delegation.",
  },
  "businesses.feature.test_injection": { de: "Test-E-Mails", en: "Test emails" },
  "businesses.feature.test_injection.hint": {
    de: "Erlaubt es, Testanfragen in den echten Posteingang dieses Betriebs einzuspielen. Sie verbrauchen echtes KI-Budget — nur für einen Testzeitraum aktivieren.",
    en: "Allows injecting test enquiries into this business's real inbox. They consume real AI budget — enable only for a testing period.",
  },
  "businesses.quota.ai_calls_per_month": { de: "KI-Aufrufe/Monat", en: "AI calls / month" },
  "businesses.quota.sends_per_day": { de: "Sendungen/Tag", en: "Sends / day" },
  // #935: an inherited daily send ceiling is a function of how old the business is, so the
  // number in the field needs to say where it came from — otherwise it reads as arbitrary.
  "businesses.quota.sendsWarmup": {
    de: "Aufwärmphase: Der Standardwert verdoppelt sich wöchentlich, bis er den Normalwert erreicht. Ein eigener Eintrag ersetzt ihn.",
    en: "Warmup: the inherited default doubles every week until it reaches the ordinary limit. Setting a value here replaces it.",
  },
  "businesses.quota.google_places_requests_per_month": { de: "Google-Places-Aufrufe/Monat", en: "Google Places calls / month" },
  "businesses.quota.usageTitle": { de: "Aktuelle Nutzung / Limit", en: "Current usage / limit" },
  "businesses.features.googleQuotaTitle": { de: "Globales Google-Places-Kontingent", en: "Global Google Places quota" },
  "businesses.features.googleQuotaHint": {
    de: "Installationsweites Limit für kostenpflichtige Aufrufe. 0 stoppt Google-Aufrufe sofort; maximal {max}. Bekannte Orte bleiben verfügbar.",
    en: "Installation-wide paid-call cap. 0 stops Google calls immediately; maximum {max}. Known venues remain available.",
  },
  "businesses.features.googleQuotaUsage": { de: "Nutzung / Limit", en: "Usage / limit" },
  "businesses.features.googleQuotaLimit": { de: "Globales Monatslimit", en: "Global monthly limit" },
  "businesses.features.googleQuotaSave": { de: "Google-Limit speichern", en: "Save Google limit" },
  "businesses.features.googleQuotaSaved": { de: "Globales Google-Limit gespeichert.", en: "Global Google limit saved." },
  "businesses.features.googleQuotaInvalid": { de: "Das Limit muss eine ganze Zahl zwischen 0 und {max} sein.", en: "The limit must be an integer between 0 and {max}." },
  "businesses.features.googleQuotaWindow": { de: "UTC-Zeitraum: {from} bis {to}", en: "UTC window: {from} to {to}" },
  "businesses.features.planTitle": { de: "Betriebsweite Kontingente", en: "Business-wide quotas" },
  "businesses.features.colQuota": { de: "Kontingent", en: "Quota" },
  "businesses.features.colUsageLimit": { de: "Nutzung / Limit", en: "Usage / limit" },
  "businesses.planQuota.operators_max": { de: "Operatoren max.", en: "Max operators" },
  "mailbox.title": { de: "Postfächer", en: "Mailboxes" },
  "mailbox.none": { de: "Noch kein Postfach eingerichtet.", en: "No mailbox provisioned yet." },
  "mailbox.add": { de: "Postfach hinzufügen", en: "Add mailbox" },
  "mailbox.edit": { de: "Postfach bearbeiten", en: "Edit mailbox" },
  "mailbox.editAction": { de: "Bearbeiten", en: "Edit" },
  "mailbox.enabled": { de: "Aktiv", en: "Enabled" },
  "mailbox.disabled": { de: "Deaktiviert", en: "Disabled" },
  "mailbox.retired": { de: "Stillgelegt", en: "Retired" },
  "mailbox.enable": { de: "Aktivieren", en: "Enable" },
  "mailbox.disable": { de: "Deaktivieren", en: "Disable" },
  "mailbox.check": { de: "Verbindung prüfen", en: "Check connection" },
  "mailbox.checking": { de: "Prüfe…", en: "Checking…" },
  "mailbox.checkTitle": { de: "Verbindungstest (nur lesend)", en: "Connection check (read-only)" },
  "mailbox.checkOk": { de: "OK", en: "OK" },
  "mailbox.checkFail": { de: "Fehlgeschlagen", en: "Failed" },
  "mailbox.checkMessages": { de: "{count} Nachrichten im Ordner", en: "{count} messages in the folder" },
  "mailbox.checkNoSmtp": { de: "Nicht konfiguriert", en: "Not configured" },
  "mailbox.host": { de: "Server", en: "Host" },
  "mailbox.port": { de: "Port", en: "Port" },
  "mailbox.email": { de: "E-Mail-Adresse", en: "Email address" },
  "mailbox.folder": { de: "Ordner", en: "Folder" },
  "mailbox.password": { de: "Passwort", en: "Password" },
  "mailbox.imapPassword": { de: "IMAP-Passwort", en: "IMAP password" },
  "mailbox.smtpPassword": { de: "SMTP-Passwort", en: "SMTP password" },
  "mailbox.passwordKeepHint": {
    de: "Leer lassen, um das gespeicherte Passwort zu behalten.",
    en: "Leave blank to keep the stored password.",
  },
  "mailbox.credsNote": {
    de: "Zugangsdaten werden verschlüsselt gespeichert und nach dem Speichern nie wieder angezeigt.",
    en: "Credentials are stored encrypted and are never shown again after saving.",
  },
  "mailbox.tlsMismatch": {
    de: "TLS-Hostname-Abweichung erlauben (Zertifikatskette wird weiter geprüft)",
    en: "Allow TLS hostname mismatch (certificate chain is still verified)",
  },
  "mailbox.tlsServername": { de: "Erwarteter TLS-Servername", en: "Expected TLS servername" },
  "mailbox.smtpUser": { de: "SMTP-Benutzer", en: "SMTP user" },
  "mailbox.smtpFrom": { de: "Absenderadresse (From)", en: "From address" },
  "mailbox.smtpFromName": { de: "Absendername", en: "From name" },
  "mailbox.smtpSecure": { de: "Implizites TLS (Port 465)", en: "Implicit TLS (port 465)" },
  "mailbox.save": { de: "Speichern", en: "Save" },
  "mailbox.saving": { de: "Speichere…", en: "Saving…" },
  "mailbox.created": { de: "Postfach angelegt", en: "Mailbox created" },
  "mailbox.updated": { de: "Postfach aktualisiert", en: "Mailbox updated" },

  // ---- product-hosted mailbox, offered at registration (#710) ----
  "neoMailbox.choice.title": { de: "Wie soll {product} E-Mails empfangen?", en: "How should {product} receive email?" },
  "neoMailbox.choice.hosted": { de: "{productCompound}-Postfach", en: "{product} mailbox" },
  "neoMailbox.choice.hostedHint": {
    de: "Wir richten eine Adresse ein. Sie brauchen keine Zugangsdaten und nichts zu konfigurieren.",
    en: "We set an address up for you. No credentials to find, nothing to configure.",
  },
  "neoMailbox.choice.own": { de: "Eigenes Postfach", en: "Your own mailbox" },
  "neoMailbox.choice.ownHint": {
    de: "Sie verbinden Ihre bestehende Geschäftsadresse über IMAP. Der übliche Weg, wenn Sie bereits eine haben.",
    en: "Connect the business address you already use over IMAP. The normal path if you have one.",
  },
  "neoMailbox.localPart.label": { de: "Wunschadresse", en: "Address you want" },
  "neoMailbox.localPart.rule": {
    de: "3 bis 64 Zeichen: a–z, 0–9 sowie . - und _ — nicht am Anfang oder Ende und nicht zwei direkt hintereinander.",
    en: "3 to 64 characters: a–z, 0–9 and . - _ — not at the start or end, and never two in a row.",
  },
  "neoMailbox.checking": { de: "Wird geprüft…", en: "Checking…" },
  "neoMailbox.available": { de: "{address} ist frei.", en: "{address} is free." },
  "neoMailbox.taken": { de: "{address} ist bereits vergeben.", en: "{address} is already taken." },
  // #1163: a throttled check is not a failed one — the name may well be free, the server just
  // asked for a pause. Saying "failed" here made people retype, which is what got them throttled.
  "neoMailbox.throttled": {
    de: "Zu viele Prüfungen in kurzer Zeit. Bitte warten Sie einen Moment und tippen Sie dann weiter.",
    en: "Too many checks in a short time. Wait a moment, then keep typing.",
  },
  "neoMailbox.checkFailed": {
    de: "Die Verfügbarkeit ließ sich gerade nicht prüfen. Beim Anlegen wird sie erneut geprüft.",
    en: "Availability could not be checked just now. It is checked again when the mailbox is created.",
  },

  // Why each name was refused. The rules live in the backend and it returns a reason code;
  // only the wording is here, so the two can never disagree about what is allowed.
  "neoMailbox.reason.too_short": { de: "Der Name ist zu kurz — mindestens 3 Zeichen.", en: "Too short — at least 3 characters." },
  "neoMailbox.reason.too_long": { de: "Der Name ist zu lang — höchstens 64 Zeichen.", en: "Too long — at most 64 characters." },
  "neoMailbox.reason.charset": {
    de: "Erlaubt sind nur a–z, 0–9 sowie . - und _",
    en: "Only a–z, 0–9 and . - _ are allowed.",
  },
  "neoMailbox.reason.edge_punctuation": {
    de: "Der Name darf nicht mit . - oder _ beginnen oder enden.",
    en: "The name may not start or end with . - or _",
  },
  "neoMailbox.reason.adjacent_punctuation": {
    de: "Zwei Sonderzeichen dürfen nicht direkt aufeinanderfolgen.",
    en: "Two punctuation characters may not sit next to each other.",
  },
  "neoMailbox.reason.reserved": {
    de: "Dieser Name ist reserviert und kann nicht vergeben werden.",
    en: "That name is reserved and cannot be issued.",
  },

  // ---- mail that was not an enquiry (#794) ----
  // #708 makes the business address public, so its inbox receives newsletters, auto-replies and
  // bounces. These are set aside, never deleted by the pipeline, and this is where an operator
  // asking "where did that enquiry go" finds the answer. Only the team deletes one, through the
  // trash (#2433).
  "shell.filed": { de: "Aussortiert", en: "Filed" },
  // #2104: the name of the head button that opens Filed while mail waits there.
  "overview.filedOpen": { de: "Aussortiert ({n} ungelesen)", en: "Filed ({n} unread)" },
  "filed.title": { de: "Aussortierte E-Mails", en: "Filed email" },
  "filed.intro": {
    de: "Diese Nachrichten wurden als Nicht-Anfragen aussortiert, zum Beispiel Werbung, Newsletter oder automatische Antworten. Sie bleiben erhalten, bis Sie sie als Anfrage übernehmen oder in den Papierkorb verschieben.",
    en: "These messages were filed as non-enquiries, such as unsolicited offers, newsletters or automatic replies. They are kept until you turn them into requests or move them to the trash.",
  },
  "filed.countTitle": { de: "Übersicht", en: "Overview" },
  "filed.count": {
    de: "{open} noch aussortiert, {total} insgesamt.",
    en: "{open} still filed, {total} in total.",
  },
  "filed.scope.open": { de: "Noch aussortiert", en: "Still filed" },
  "filed.scope.all": { de: "Alle", en: "All" },
  "filed.scope.trash": { de: "Papierkorb", en: "Trash" },
  "filed.filtersAria": { de: "Aussortierte E-Mails filtern", en: "Filter filed emails" },
  "filed.resultsAria": { de: "Aussortierte E-Mails", en: "Filed email results" },
  "filed.loading": { de: "Wird geladen…", en: "Loading…" },
  "filed.loadFailed": {
    de: "Die aussortierten E-Mails ließen sich nicht laden.",
    en: "The filed email could not be loaded.",
  },
  "filed.openingFailed": {
    de: "Der Lesestatus konnte nicht gespeichert werden.",
    en: "The read status could not be saved.",
  },
  "filed.empty": { de: "Nichts aussortiert.", en: "Nothing filed." },
  "filed.noSubject": { de: "(ohne Betreff)", en: "(no subject)" },
  "filed.open": { de: "Anzeigen", en: "Show" },
  "filed.close": { de: "Schließen", en: "Close" },
  "filed.whyTitle": { de: "Warum aussortiert:", en: "Why it was filed:" },
  "filed.technicalDetails": { de: "Technische Details", en: "Technical details" },
  "filed.noSignals": { de: "Keine technischen Details gespeichert.", en: "No technical details recorded." },
  "filed.explanation.bulk": {
    de: "Die E-Mail ist als Massenversand gekennzeichnet.",
    en: "The email is marked as bulk mail.",
  },
  "filed.explanation.auto_submitted": {
    de: "Die E-Mail ist als automatisch erzeugt gekennzeichnet.",
    en: "The email is marked as automatically generated.",
  },
  "filed.explanation.null_return_path": {
    de: "Die E-Mail hat eine leere Rücksendeadresse für Zustellmeldungen.",
    en: "The email has an empty return address for delivery notifications.",
  },
  "filed.explanation.unauthenticated": {
    de: "Die Authentifizierungsprüfung hat den Absender nicht bestätigt.",
    en: "The authentication check did not verify the sender.",
  },
  "filed.explanation.spam_score": {
    de: "Die Spam-Bewertung unseres Mailservers liegt über dem Grenzwert.",
    en: "Our mail server’s spam score exceeds the threshold.",
  },
  "filed.promote": { de: "Ist doch eine Anfrage", en: "This is an enquiry" },
  "filed.promoted": { de: "Als Anfrage übernommen.", en: "Taken over as a request." },
  "filed.alreadyPromoted": {
    de: "Diese Nachricht war bereits übernommen.",
    en: "This message had already been taken over.",
  },
  "filed.promoteFailed": {
    de: "Die Nachricht ließ sich nicht übernehmen.",
    en: "The message could not be taken over.",
  },
  "filed.promotedNote": { de: "bereits übernommen", en: "already taken over" },
  "filed.openRequest": { de: "Anfrage öffnen", en: "Open the request" },
  // #2433: the Filed trash, with the same retention period as the request trash.
  "filed.trash.move": { de: "In den Papierkorb", en: "Move to trash" },
  "filed.trash.confirmTitle": { de: "E-Mail in den Papierkorb verschieben?", en: "Move this email to the trash?" },
  "filed.trash.confirmBody": {
    de: "Die E-Mail verschwindet aus „Aussortiert“ und liegt dort unter „Papierkorb“. Sie kann {days} Tage lang wiederhergestellt werden und wird danach endgültig gelöscht. Im Postfach selbst bleibt sie unverändert.",
    en: "The email leaves Filed and appears under Trash there. It can be restored for {days} days and is then deleted for good. The mailbox itself is not changed.",
  },
  "filed.trash.count": {
    de: "{n} im Papierkorb. Nach {days} Tagen wird eine E-Mail endgültig gelöscht.",
    en: "{n} in the trash. An email is deleted for good after {days} days.",
  },
  "filed.trash.empty": { de: "Der Papierkorb ist leer.", en: "The trash is empty." },
  "filed.trash.purgeAt": { de: "Wird am {date} endgültig gelöscht", en: "Deleted for good on {date}" },
  "filed.trash.restore": { de: "Wiederherstellen", en: "Restore" },
  "filed.trash.movedToast": { de: "In den Papierkorb verschoben", en: "Moved to trash" },
  "filed.trash.restoredToast": { de: "Aus dem Papierkorb wiederhergestellt", en: "Restored from trash" },
  "filed.trash.failed": {
    de: "Die E-Mail konnte nicht in den Papierkorb verschoben werden.",
    en: "Could not move the email to the trash.",
  },
  "filed.trash.restoreFailed": {
    de: "Die E-Mail konnte nicht wiederhergestellt werden.",
    en: "Could not restore the email.",
  },
  "filed.trash.refused.already_in_trash": {
    de: "Die E-Mail liegt im Papierkorb. Stellen Sie sie zuerst wieder her.",
    en: "The email is in the trash. Restore it first.",
  },
  "filed.trash.refused.not_in_trash": {
    de: "Die E-Mail liegt nicht mehr im Papierkorb.",
    en: "The email is no longer in the trash.",
  },
  "filed.trash.refused.promoted": {
    de: "Die E-Mail wurde bereits als Anfrage übernommen.",
    en: "The email was already taken over as a request.",
  },
  "filed.trash.refused.purge_due": {
    de: "Die Frist im Papierkorb ist abgelaufen. Die E-Mail wird endgültig gelöscht.",
    en: "The trash period is over. The email is being deleted for good.",
  },
  // The reason is the transport fact that decided it, in words an operator can act on.
  "filed.reason.bulk": { de: "Massenversand", en: "Bulk mail" },
  "filed.reason.auto_submitted": { de: "Automatisch erzeugt", en: "Automatically generated" },
  "filed.reason.null_return_path": { de: "Keine Antwortadresse", en: "No return address" },
  "filed.reason.unauthenticated": { de: "Absender nicht bestätigt", en: "Sender not authenticated" },
  // The odd one out: our own server scored it, so the label says so rather than naming a
  // header the sender sent.
  "filed.reason.model_non_enquiry": { de: "Inhaltlich keine Anfrage", en: "Content is not an enquiry" },
  "filed.explanation.model_non_enquiry": {
    de: "Die Inhaltsanalyse hat keinen Bezug zu Catering oder einer Veranstaltung erkannt. Bei einem Irrtum können Sie die Nachricht als Anfrage übernehmen.",
    en: "Content analysis found no connection to catering or an event. If this is incorrect, you can turn the message into a request.",
  },
  "filed.category.spam": { de: "Unerwünschte Werbung oder Spam", en: "Unsolicited offer or spam" },
  "filed.category.bulk_mailing": { de: "Newsletter oder Massenversand", en: "Newsletter or bulk mailing" },
  "filed.category.unrelated_to_catering": { de: "Ohne Bezug zu Catering oder Veranstaltungen", en: "Unrelated to catering or events" },
  "filed.evidence.subject": { de: "Beleg im Betreff", en: "Evidence in the subject" },
  "filed.evidence.body": { de: "Beleg im Nachrichtentext", en: "Evidence in the message" },
  "filed.reason.spam_score": { de: "Als Spam bewertet", en: "Scored as spam" },

  "neoMailbox.terms.title": { de: "Was Sie bekommen", en: "What you get" },
  "neoMailbox.terms.body": {
    de: "E-Mails an diese Adresse kommen in {product} an. Sie können sich mit einem E-Mail-Programm nicht in dieses Postfach einloggen, und die Adresse lässt sich nicht zu einem anderen Anbieter mitnehmen — sie gehört zur {productCompound}-Domain.",
    en: "Mail to this address arrives in {product}. You cannot log into this mailbox with a mail client, and the address cannot be taken to another provider — it belongs to the {product} domain.",
  },
  // Owner decision on #793, 2026-08-20: an address closes silently — no forwarding, no bounce
  // naming a successor. #708 established that this address is public and gets printed on websites,
  // flyers and social media, which makes the silence the part a business has to read BEFORE it
  // prints anything. Saying only "the mailbox is closed" would leave them to discover the rest
  // from customers who never got an answer. See PILOT_ROLLOUT_RUNBOOK.md §9.
  "neoMailbox.terms.leaving": {
    de: "Wenn Sie {product} verlassen, wird das Postfach geschlossen und die Adresse nimmt keine E-Mails mehr an. Weitergeleitet wird nichts: Wer danach an die Adresse schreibt, erreicht Sie nicht mehr und erfährt nur, dass es sie nicht mehr gibt. Ändern Sie die Adresse deshalb vorher überall dort, wo Sie sie veröffentlicht haben — auf Ihrer Website, auf Flyern, in Ihren Profilen. Vergeben wird sie an niemanden: Ihre Adresse bekommt später kein anderer Betrieb.",
    en: "If you leave {product} the mailbox is closed and the address stops accepting mail. Nothing is forwarded: anyone writing to it afterwards no longer reaches you, and all they learn is that the address no longer exists. So change the address everywhere you published it — your website, your flyers, your profiles — before you go. It is never issued again either: no other business gets your address later.",
  },

  "neoMailbox.provisioning": { de: "Postfach wird eingerichtet…", en: "Setting the mailbox up…" },
  "neoMailbox.provisioned": { de: "Postfach {address} ist eingerichtet und aktiv.", en: "Mailbox {address} is set up and active." },
  "neoMailbox.provisionFailed.title": { de: "Das Postfach wurde nicht eingerichtet", en: "The mailbox was not set up" },
  "neoMailbox.provisionFailed.body": {
    de: "Der Betrieb ist angelegt — es steht nichts halb da. Das Postfach können Sie unter „Postfächer“ erneut einrichten.",
    en: "The business exists — nothing is half-created. You can set the mailbox up again under “Mailboxes”.",
  },
  // ---- handing a prepared business over (#780) ----
  // Every product mention is `{product}`, resolved centrally (#782) — the product is currently
  // named after one of its own customers and the real name is not decided yet.
  "invite.owner.title": { de: "Übergabe-Link", en: "Handover link" },
  "invite.owner.hint": {
    de: "Legen Sie den Betrieb mit den Daten an, die Sie haben. Mit E-Mail-Adresse schicken wir den Link direkt an den künftigen Inhaber, ohne geben Sie ihn selbst weiter. Er ergänzt die fehlenden Angaben, wählt sein Passwort und schaltet den Betrieb damit frei.",
    en: "Create the business with the details you have. With an email address we send the link straight to its future owner; without one you pass it on yourself. They fill in what is missing, choose their password, and that activates the business.",
  },
  "invite.owner.emailLabel": { de: "E-Mail des Inhabers (optional)", en: "Owner's email (optional)" },
  "invite.owner.nameLabel": { de: "Name des Inhabers (optional)", en: "Owner's name (optional)" },
  "invite.owner.issue": { de: "Link erzeugen", en: "Create link" },
  "invite.owner.reissue": { de: "Neuen Link erzeugen", en: "Create a new link" },
  "invite.owner.revoke": { de: "Zurückziehen", en: "Withdraw" },
  "invite.owner.copied": { de: "Link kopiert", en: "Link copied" },
  "invite.owner.copy": { de: "Kopieren", en: "Copy" },
  "invite.owner.once": {
    de: "Dieser Link wird genau einmal angezeigt. Er lässt sich später nicht wieder aufrufen — geht er verloren, erzeugen Sie einen neuen; der alte wird dabei ungültig.",
    en: "This link is shown exactly once and cannot be looked up again. If it is lost, create a new one — that invalidates the old one.",
  },
  "invite.owner.reissueWarning": {
    de: "Ein neuer Link macht den bisherigen sofort ungültig.",
    en: "A new link immediately invalidates the previous one.",
  },
  "invite.owner.emailed": {
    de: "Der Link wurde an {email} geschickt.",
    en: "The link was emailed to {email}.",
  },
  "invite.owner.notEmailed": {
    de: "Die E-Mail konnte nicht verschickt werden. Geben Sie den Link bitte selbst weiter.",
    en: "The email could not be sent. Please pass the link on yourself.",
  },
  "invite.owner.expires": { de: "Gültig bis {date}", en: "Valid until {date}" },
  "invite.owner.none": { de: "Noch kein Link erzeugt.", en: "No link created yet." },
  // #1164: the panel in three blocks — the link just made, the history, the form.
  "invite.owner.currentLink": { de: "Aktueller Link", en: "Current link" },
  "invite.owner.currentLinkLabel": { de: "Übergabe-Link, nur jetzt sichtbar", en: "Handover link, visible only now" },
  "invite.owner.copiedShort": { de: "Kopiert", en: "Copied" },
  "invite.owner.copyFailed": {
    de: "Kopieren war nicht möglich. Der Link ist markiert – bitte mit Strg+C kopieren.",
    en: "Copying was not possible. The link is selected – copy it with Ctrl+C.",
  },
  "invite.owner.history": { de: "Bisherige Links", en: "Previous links" },
  "invite.owner.col.status": { de: "Status", en: "Status" },
  "invite.owner.col.invited": { de: "Eingeladen", en: "Invited" },
  "invite.owner.col.created": { de: "Erstellt", en: "Created" },
  "invite.owner.col.expires": { de: "Gültig bis", en: "Valid until" },
  "invite.owner.col.action": { de: "Aktion", en: "Action" },
  "invite.owner.createTitle": { de: "Neuen Link erzeugen", en: "Create a new link" },
  "invite.owner.handedOver": {
    de: "Der Betrieb wurde übergeben und hat einen eigenen Zugang. Ein weiterer Übergabe-Link ist nicht möglich.",
    en: "The business has been handed over and has its own account. A further handover link is not possible.",
  },
  // ---- a business inviting its own colleagues (#1298) ----
  // Reuses the states, the columns and the copy affordance above; only what differs is new. The
  // difference that matters is the absence of a password field, and the wording says so, because
  // the person doing this used to have to invent one and pass it on.
  "staffInvite.title": { de: "Kollegin oder Kollegen einladen", en: "Invite a colleague" },
  "staffInvite.hint": {
    de: "Der Einladungslink geht per E-Mail an die angegebene Adresse; Sie sehen anschließend, ob er verschickt wurde. Die Person wählt ihr Passwort selbst – Sie müssen keines vergeben und keines weitersagen.",
    en: "The invitation link is emailed to the address you enter, and you are then told whether it went. The person chooses their own password – you never set one and never have to pass one on.",
  },
  "staffInvite.emailLabel": { de: "E-Mail-Adresse", en: "Email address" },
  "staffInvite.nameLabel": { de: "Name (optional)", en: "Name (optional)" },
  "staffInvite.issue": { de: "Einladungslink erzeugen", en: "Create invitation link" },
  "staffInvite.createTitle": { de: "Neue Einladung", en: "New invitation" },
  "staffInvite.history": { de: "Einladungen", en: "Invitations" },
  "staffInvite.none": { de: "Noch keine Einladung erzeugt.", en: "No invitation created yet." },
  "staffInvite.allAccepted": { de: "Alle Einladungen wurden eingelöst.", en: "All invitations have been accepted." },
  "staffInvite.currentLink": { de: "Link für {email}", en: "Link for {email}" },
  "staffInvite.currentLinkLabel": {
    de: "Einladungslink, nur jetzt sichtbar",
    en: "Invitation link, visible only now",
  },
  "staffInvite.once": {
    de: "Dieser Link wird genau einmal angezeigt und lässt sich später nicht wieder aufrufen. Geht er verloren, erzeugen Sie einen neuen; der alte wird dabei ungültig.",
    en: "This link is shown exactly once and cannot be looked up again. If it is lost, create a new one — that invalidates the old one.",
  },
  "staffInvite.emailed": {
    de: "Der Link wurde an {email} geschickt.",
    en: "The link was emailed to {email}.",
  },
  "staffInvite.notEmailed": {
    de: "Die E-Mail konnte nicht verschickt werden. Geben Sie den Link bitte selbst weiter.",
    en: "The email could not be sent. Please pass the link on yourself.",
  },
  "staffInvite.reissueWarning": {
    de: "Für diese Adresse ist bereits ein Link offen. Ein neuer macht den bisherigen sofort ungültig.",
    en: "A link for this address is already outstanding. A new one immediately invalidates it.",
  },
  "staffInvite.accept.routeTitle": { de: "Einladung ins Team", en: "Team invitation" },
  "staffInvite.accept.title": { de: "Willkommen bei {business}", en: "Welcome to {business}" },
  "staffInvite.accept.sub": {
    de: "Wählen Sie ein Passwort – danach können Sie sich anmelden.",
    en: "Choose a password – after that you can sign in.",
  },
  "staffInvite.accept.emailFixed": {
    de: "Damit melden Sie sich an. Die Einladung gilt genau für diese Adresse und lässt sich hier nicht ändern.",
    en: "This is what you will sign in with. The invitation is for this address only and cannot be changed here.",
  },
  "staffInvite.accept.submit": { de: "Zugang einrichten", en: "Set my account up" },
  "staffInvite.accept.submitting": { de: "Wird eingerichtet…", en: "Setting up…" },

  "invite.state.outstanding": { de: "Offen", en: "Outstanding" },
  "invite.state.expired": { de: "Abgelaufen", en: "Expired" },
  "invite.state.revoked": { de: "Zurückgezogen", en: "Withdrawn" },
  "invite.state.accepted": { de: "Eingelöst", en: "Accepted" },

  "invite.accept.title": { de: "Betrieb einrichten", en: "Set your business up" },
  "invite.accept.sub": {
    de: "Prüfen Sie die Angaben, ergänzen Sie das Fehlende und wählen Sie ein Passwort. Danach ist Ihr Betrieb in {product} einsatzbereit.",
    en: "Check the details, fill in what is missing and choose a password. Your business is then ready to use in {product}.",
  },
  "invite.accept.companyLabel": { de: "Name des Betriebs", en: "Business name" },
  "invite.accept.businessTitle": { de: "Ihr Betrieb", en: "Business" },
  "invite.accept.accessTitle": { de: "Ihr Zugang", en: "Your access" },
  // #1321: the value is a purely internal identifier — not in any URL, not part of the
  // business's email address, seen by no customer. The old label said only what characters
  // were allowed, which left the person guessing whether their customers would read it.
  "invite.accept.slugLabel": { de: "Interner Kurzname", en: "Internal short name" },
  "invite.accept.slugHint": {
    de: "Ein kurzer technischer Name für Ihren Betrieb. Er wird nur intern verwendet — Ihre Kundschaft sieht ihn nie. Nur Kleinbuchstaben, Ziffern und Bindestriche.",
    en: "A short technical name for your business. It is only used internally — your customers never see it. Lowercase letters, digits and hyphens only.",
  },
  "invite.accept.nameLabel": { de: "Ihr Name", en: "Your name" },
  "invite.accept.emailLabel": { de: "Ihre E-Mail-Adresse", en: "Your email address" },
  "invite.accept.emailHint": {
    de: "Damit melden Sie sich künftig an.",
    en: "This is what you will sign in with.",
  },
  "invite.accept.passwordLabel": { de: "Passwort", en: "Password" },
  "invite.accept.passwordHint": { de: "Mindestens 10 Zeichen.", en: "At least 10 characters." },
  "invite.accept.passwordRepeatLabel": { de: "Passwort wiederholen", en: "Repeat password" },
  "invite.accept.passwordMismatch": {
    de: "Die beiden Passwörter stimmen nicht überein.",
    en: "The two passwords do not match.",
  },
  "invite.accept.submit": { de: "Betrieb freischalten", en: "Activate the business" },
  "invite.accept.submitting": { de: "Wird eingerichtet…", en: "Setting up…" },
  "invite.accept.invalidTitle": { de: "Dieser Link ist nicht mehr gültig", en: "This link is no longer valid" },
  "invite.accept.invalidBody": {
    de: "Dieser Einladungslink kann nicht verwendet werden. Bitten Sie die Person, die Sie eingeladen hat, um einen neuen Link.",
    en: "This invitation link cannot be used. Ask the person who invited you for a new link.",
  },
  "invite.accept.contextTitle": { de: "Einladung zu {product}", en: "Invitation to {product}" },
  "invite.accept.toLogin": { de: "Zur Anmeldung", en: "Back to sign in" },
  "invite.accept.loading": { de: "Einladung wird geprüft…", en: "Checking the invitation…" },
  // The address step. Worded as a one-time decision because that is exactly what it is (#779):
  // there is no screen anywhere in the product that lets the business change it afterwards.
  "invite.accept.mailboxTitle": { de: "Ihre E-Mail-Adresse für Anfragen", en: "Your address for enquiries" },
  "invite.accept.mailboxHint": {
    de: "An diese Adresse gerichtete Anfragen landen direkt in {product}. Die Adresse wird jetzt einmalig festgelegt und lässt sich später nicht mehr selbst ändern. Sie können den Schritt auch überspringen und die Adresse später von uns einrichten lassen.",
    en: "Enquiries sent to this address arrive directly in {product}. It is set once, now, and cannot be changed by you later. You can also skip this step and have us set the address up afterwards.",
  },
  // Every way the form can be refused, in German. The server names the reason; the wording is
  // ours, exactly as with the address picker — a customer-facing screen never shows API English.
  // #1163: the throttle is not a refusal of the link. The link stays valid; the person waits.
  "invite.accept.throttledTitle": { de: "Zu viele Versuche", en: "Too many attempts" },
  "invite.accept.throttledBody": {
    de: "Von Ihrem Anschluss kamen in kurzer Zeit zu viele Aufrufe. Der Link bleibt gültig: Warten Sie etwa {minutes} Minuten und öffnen Sie denselben Link dann erneut.",
    en: "Too many requests came from your connection in a short time. The link stays valid: wait about {minutes} minutes, then open the same link again.",
  },
  "invite.accept.refusal.throttled": {
    de: "Zu viele Versuche in kurzer Zeit. Ihre Eingaben bleiben erhalten – bitte warten Sie einen Moment und senden Sie das Formular dann erneut ab.",
    en: "Too many attempts in a short time. Your entries are kept – wait a moment, then submit the form again.",
  },
  "invite.accept.refusal.invalidEmail": {
    de: "Diese E-Mail-Adresse sieht nicht gültig aus. Bitte prüfen Sie die Schreibweise.",
    en: "That email address does not look valid. Please check the spelling.",
  },
  "invite.accept.refusal.invalidSlug": {
    de: "Der interne Kurzname darf nur Kleinbuchstaben, Ziffern und Bindestriche enthalten, muss mit einem Buchstaben oder einer Ziffer beginnen und höchstens 63 Zeichen lang sein.",
    en: "The internal short name may contain only lowercase letters, digits and hyphens, must start with a letter or digit, and be at most 63 characters.",
  },
  "invite.accept.refusal.tooLong": {
    de: "Eine Ihrer Angaben ist zu lang. Bitte kürzen Sie sie auf höchstens 200 Zeichen.",
    en: "One of your entries is too long. Please shorten it to at most 200 characters.",
  },
  "invite.accept.refusal.emailUnavailable": {
    de: "Mit dieser E-Mail-Adresse lässt sich kein Zugang anlegen. Bitte verwenden Sie eine andere.",
    en: "An account cannot be created with this email address. Please use a different one.",
  },
  "invite.accept.refusal.slugTaken": {
    de: "Dieser interne Kurzname ist bereits vergeben. Bitte wählen Sie einen anderen.",
    en: "That internal short name is already taken. Please choose another.",
  },
  "invite.accept.refusal.alreadyUsed": {
    de: "Dieser Link wurde bereits eingelöst. Falls das nicht Sie waren, melden Sie sich bitte bei uns.",
    en: "This link has already been redeemed. If that was not you, please contact us.",
  },
  // #1298: the business is at its seat limit. Nothing the invited person can do about it, so the
  // wording points them back at whoever invited them instead of at a field they could correct.
  "invite.accept.refusal.seatCap": {
    de: "Der Betrieb hat keinen freien Zugang mehr. Bitte wenden Sie sich an die Person, die Sie eingeladen hat.",
    en: "The business has no free seat left. Please contact the person who invited you.",
  },
  "invite.accept.refusal.generic": {
    de: "Die Einrichtung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut oder melden Sie sich bei uns.",
    en: "Setting up could not be completed. Please try again or contact us.",
  },
  "invite.accept.mailboxAck": {
    de: "Ich habe verstanden, dass diese Adresse dauerhaft zu meinem Betrieb gehört und von mir später nicht mehr geändert werden kann.",
    en: "I understand this address belongs to my business permanently and cannot be changed by me later.",
  },
  "invite.accept.mailboxAckRequired": {
    de: "Bitte bestätigen Sie die Adresse, oder lassen Sie das Feld leer, um den Schritt zu überspringen.",
    en: "Please confirm the address, or leave the field empty to skip this step.",
  },
  "invite.accept.mailboxFailedTitle": {
    de: "Betrieb eingerichtet — E-Mail-Adresse noch nicht",
    en: "Business set up — address not yet",
  },
  "invite.accept.mailboxFailedBody": {
    de: "Ihr Zugang und Ihr Betrieb sind angelegt und Sie können sofort loslegen. Nur die gewünschte E-Mail-Adresse konnte nicht eingerichtet werden. Bitte melden Sie sich bei uns, damit wir das nachholen.",
    en: "Your account and your business exist and you can start right away. Only the address you asked for could not be set up. Please contact us so we can finish it.",
  },
  "invite.accept.mailboxFailedContinue": { de: "Weiter zu {product}", en: "Continue to {product}" },

  // ---- Settings → Email: every way enquiries arrive, and where replies leave from (#1432) ----
  "settingsEmail.lead": {
    de: "Wie Anfragen Sie erreichen und von welcher Adresse Ihre Antworten ausgehen.",
    en: "How enquiries reach you, and which address your replies leave from.",
  },
  "settingsEmail.waysAria": { de: "Wege, auf denen Anfragen ankommen", en: "Ways enquiries reach you" },
  "settingsEmail.unavailable": { de: "Nicht verfügbar", en: "Not available" },
  "settingsEmail.unavailableDetail": {
    de: "Konnte gerade nicht gelesen werden. Laden Sie die Seite später neu.",
    en: "Could not be read just now. Reload the page later.",
  },
  "settingsEmail.notSetUp": { de: "Nicht eingerichtet", en: "Not set up" },
  "settingsEmail.open.howTo": { de: "So nutzen Sie sie", en: "How to use it" },
  "settingsEmail.open.manage": { de: "Verwalten", en: "Manage" },
  "settingsEmail.open.setUp": { de: "Einrichten", en: "Set up" },
  "settingsEmail.open.details": { de: "Details", en: "Details" },
  "settingsEmail.address.titleOwn": { de: "Ihre Arbeitsadresse", en: "Your working address" },
  "settingsEmail.address.active": { de: "Aktiv", en: "Active" },
  "settingsEmail.address.missing": { de: "Fehlt", en: "Missing" },
  "settingsEmail.address.missingDetail": {
    de: "Für diesen Betrieb ist noch keine Adresse eingerichtet. Bitte melden Sie sich bei uns, damit wir das nachholen.",
    en: "No address has been set up for this business yet. Please contact us so we can finish it.",
  },
  "settingsEmail.forwarding.title": { de: "Ihr Postfach weiterleiten", en: "Forward your mailbox" },
  "settingsEmail.forwarding.detail": {
    de: "Anfragen aus dem Postfach, das Sie schon nutzen, hierher weiterleiten.",
    en: "Forward enquiries from the mailbox you already use.",
  },
  "settingsEmail.forwarding.none": { de: "Keine Absender", en: "No senders" },
  "settingsEmail.forwarding.one": { de: "1 Absender", en: "1 sender" },
  "settingsEmail.forwarding.many": { de: "{count} Absender", en: "{count} senders" },
  "settingsEmail.domain.title": { de: "Ihre eigene Domain", en: "Your own domain" },
  "settingsEmail.domain.detailNone": {
    de: "Eine Adresse auf Ihrer eigenen Domain",
    en: "An address on your own domain",
  },
  "settingsEmail.domain.onePer": { de: "Eine pro Betrieb", en: "One per business" },
  "settingsEmail.mailbox.title": { de: "Ihr eigenes Postfach (IMAP/SMTP)", en: "Your own mailbox (IMAP/SMTP)" },
  "settingsEmail.mailbox.connected": { de: "Verbunden", en: "Connected" },
  "settingsEmail.mailbox.detailNone": {
    de: "Ein Postfach, das Sie schon haben, lesen und darüber antworten.",
    en: "Read a mailbox you already have, and reply through it.",
  },
  "settingsEmail.mailbox.byOwner": {
    de: "Richtet der Plattformbetreiber für Sie ein.",
    en: "Set up by the platform owner.",
  },
  "settingsEmail.mailbox.adminNote": {
    de: "Eigene Postfächer richtet der Plattformbetreiber ein und ändert sie auch. Melden Sie sich bei uns, wenn Anfragen aus einem Postfach gelesen werden sollen, das Sie schon haben.",
    en: "Own mailboxes are set up and changed by the platform owner. Contact us if enquiries should be read from a mailbox you already have.",
  },
  "settingsEmail.replies.title": { de: "Absender Ihrer Antworten", en: "Replies leave from" },
  "settingsEmail.replies.lead": {
    de: "Eine Anfrage wird von der Adresse beantwortet, an der sie ankam, sofern diese senden kann – sonst von einer anderen Ihrer Adressen, die es kann.",
    en: "An enquiry is answered from the address it arrived at when that address can send, otherwise from another of your addresses that can.",
  },
  "settingsEmail.replies.answeredFrom": { de: "beantwortet von", en: "answered from" },
  "settingsEmail.replies.cannot": { de: "Kann noch nicht antworten", en: "Cannot reply yet" },
  "settingsEmail.replies.empty": {
    de: "Noch keine Adresse, an der Anfragen ankommen.",
    en: "No address receives enquiries yet.",
  },
  "settingsEmail.replies.signature": {
    de: "Die Signatur unter Ihren Antworten legen Sie unter „Signatur“ fest.",
    en: "The signature under your replies is set under Signature.",
  },
  "settingsEmail.replies.openSignature": { de: "Signatur bearbeiten", en: "Edit the signature" },
  "settingsEmail.kind.platform": { de: "{productCompound}-Adresse", en: "{product} address" },
  "settingsEmail.kind.ownDomain": { de: "Eigene Domain", en: "Own domain" },
  "settingsEmail.kind.ownMailbox": { de: "Eigenes Postfach", en: "Own mailbox" },

  // ---- the business's own address, read-only, and the owner-only correction (#779) ----
  "businessAddress.title": { de: "Ihre {productCompound}-Adresse", en: "Your {product} address" },
  "businessAddress.hintOwn": {
    de: "An diese Adresse gerichtete E-Mails kommen in {product} an. Sie gehört Ihnen — Sie verwalten sie wie bisher.",
    en: "Mail sent to this address arrives in {product}. It is your own mailbox, managed as before.",
  },
  // #1229: the instruction a business gets the moment its address exists, and again in Settings.
  // `forward` and `notAMailbox` are shown only for an address hosted on our mail server: one is
  // advice for a business that already publishes another address, the other is a limit that only
  // applies to ours.
  "workingAddress.title": { de: "Ihre Adresse ist bereit", en: "Your address is ready" },
  "workingAddress.lead": {
    de: "Das ist die Adresse, an die Ihre Kundinnen und Kunden schreiben. Geben Sie sie überall an, wo Anfragen entstehen:",
    en: "This is the address your customers write to. Put it everywhere enquiries start:",
  },
  "workingAddress.placeWebsite": {
    de: "Auf Ihrer Website und im Kontaktformular",
    en: "On your website and in your contact form",
  },
  "workingAddress.placeQuotes": {
    de: "In Angeboten und Rechnungen",
    en: "On quotes and invoices",
  },
  "workingAddress.placeSignature": {
    de: "In Ihrer E-Mail-Signatur",
    en: "In your email signature",
  },
  "workingAddress.arrives": {
    de: "Jede E-Mail an diese Adresse wird zu einer Anfrage, die Sie prüfen und beantworten. Nichts geht ohne Ihre Freigabe hinaus.",
    en: "Every email to this address becomes an enquiry for you to review and answer. Nothing goes out without your approval.",
  },
  "workingAddress.forward": {
    de: "Nutzen Sie bisher eine andere Adresse für Anfragen? Richten Sie dort eine Weiterleitung hierher ein, damit nichts verloren geht.",
    en: "Already using another address for enquiries? Forward it here so nothing is lost.",
  },
  "workingAddress.notAMailbox": {
    de: "Ein Postfach zum Anmelden ist das nicht — Sie arbeiten mit dieser Adresse ausschließlich hier.",
    en: "This is not a mailbox you sign into — you work with this address here only.",
  },
  "workingAddress.copy": { de: "Kopieren", en: "Copy" },
  "workingAddress.copied": { de: "Kopiert", en: "Copied" },
  "workingAddress.done": { de: "Verstanden", en: "Got it" },
  "businessAddress.hint": {
    de: "An diese Adresse gerichtete E-Mails kommen in {product} an. Die Adresse wurde bei der Registrierung festgelegt und lässt sich nachträglich nicht ändern — wenden Sie sich an uns, falls etwas nicht stimmt.",
    en: "Mail sent to this address arrives in {product}. It was set when the business was registered and cannot be changed afterwards — contact us if something is wrong.",
  },
  "neoMailbox.change": { de: "Adresse korrigieren", en: "Correct the address" },
  "neoMailbox.change.title": { de: "{productCompound}-Adresse korrigieren", en: "Correct the {product} address" },
  "neoMailbox.change.warning": {
    de: "Die bisherige Adresse {address} wird geschlossen und nimmt danach keine E-Mails mehr an. Sie wird an niemanden neu vergeben — auch nicht an diesen Betrieb. E-Mails, die während der Umstellung an die alte Adresse gehen, kommen nicht mehr an.",
    en: "The current address {address} is closed and stops accepting mail. It is never reissued to anyone, this business included. Mail sent to the old address during the change does not arrive.",
  },
  "neoMailbox.change.confirm": { de: "Adresse jetzt umstellen", en: "Change the address now" },
  "neoMailbox.changed": {
    de: "Adresse umgestellt: {address} ist aktiv, {previous} ist geschlossen.",
    en: "Address changed: {address} is live, {previous} is closed.",
  },
  // ---- #1447: owner-only change of the address a business's own domain receives at ----
  "mailDomainAddress.change": { de: "Adresse ändern", en: "Change the address" },
  "mailDomainAddress.change.title": { de: "Adresse der eigenen Domain ändern", en: "Change the own-domain address" },
  "mailDomainAddress.change.warning": {
    de: "Nur auf Wunsch des Betriebs. Die bisherige Adresse {address} wird geschlossen und nimmt danach keine E-Mails mehr an; ihr Verlauf bleibt erhalten. E-Mails, die während der Umstellung an die alte Adresse gehen, kommen nicht mehr an.",
    en: "Only at the business's request. The current address {address} is closed and stops accepting mail; its history is kept. Mail sent to the old address during the change does not arrive.",
  },
  "mailDomainAddress.change.preview": { de: "Neue Adresse: {address}", en: "New address: {address}" },
  "neoMailbox.addHosted": { de: "{productCompound}-Postfach einrichten", en: "Set up a {product} mailbox" },
  "neoMailbox.addOwn": { de: "Eigenes Postfach verbinden", en: "Connect your own mailbox" },

  // ---- the platform's own service mailboxes (#1214) ----
  "shell.platformMailboxes": { de: "Service-Postfächer", en: "Service mailboxes" },
  "platformMailbox.title": { de: "Service-Postfächer", en: "Service mailboxes" },
  "platformMailbox.sub": {
    de: "Die eigenen Postfächer der Plattform – Service-Adressen auf ihrer Mail-Domain für Social Media, Support und Ähnliches, und wo eingerichtet die Arbeitsadressen des Unternehmens. Postfächer von Betrieben werden beim Betrieb verwaltet.",
    en: "The platform's own mailboxes – service addresses on its mail domain for social media, support and the like, and where set up the company's work addresses. A business's mailboxes are managed with the business.",
  },
  "platformMailbox.workHint": {
    de: "Postfächer auf {domain} gehören Personen: Jedes hat sein eigenes Passwort und funktioniert im Webmail und in jeder Mail-App. Sie werden nicht von hier aus geöffnet, weil das ihr Passwort ersetzen würde.",
    en: "Mailboxes on {domain} belong to people: each keeps its own password and works in the webmail and in any mail app. They are not opened from here, because that would replace their password.",
  },
  "platformMailbox.domain": { de: "Domain", en: "Domain" },
  "platformMailbox.webmailHint": {
    de: "Lesen und antworten im Webmail – die Adresse ist dort der Benutzername, das Passwort das hier vergebene. Ein Postfach eines Betriebs kann nicht senden.",
    en: "Read and reply in the webmail – the address is the username there and the password is the one set here. A business's mailbox cannot send.",
  },
  "platformMailbox.create": { de: "Postfach anlegen", en: "Create mailbox" },
  "platformMailbox.createTitle": { de: "Neues Postfach", en: "New mailbox" },
  "platformMailbox.localPart": { de: "Adresse (der Teil vor dem @)", en: "Address (the part before the @)" },
  "platformMailbox.description": { de: "Beschreibung", en: "Description" },
  "platformMailbox.descriptionHint": { de: "Wofür das Postfach da ist. Erscheint nur hier.", en: "What the mailbox is for. Shown only here." },
  "platformMailbox.error.localPartRequired": { de: "Bitte eine Adresse eingeben.", en: "Please enter an address." },
  "platformMailbox.none": { de: "Der Mailserver hat auf dieser Domain noch keine Konten.", en: "The mail server has no accounts on this domain yet." },
  "platformMailbox.col.address": { de: "Adresse", en: "Address" },
  "platformMailbox.col.category": { de: "Art", en: "Kind" },
  "platformMailbox.col.description": { de: "Beschreibung", en: "Description" },
  "platformMailbox.col.created": { de: "Angelegt", en: "Created" },
  "platformMailbox.col.action": { de: "Aktion", en: "Action" },
  "platformMailbox.category.service": { de: "Service", en: "Service" },
  "platformMailbox.category.tenant": { de: "Betrieb", en: "Business" },
  "platformMailbox.category.system": { de: "System", en: "System" },
  "platformMailbox.category.unmanaged": { de: "Nicht verwaltet", en: "Unmanaged" },
  "platformMailbox.category.hint.tenant": { de: "Gehört einem Betrieb – dort verwalten.", en: "Belongs to a business – manage it there." },
  "platformMailbox.category.hint.system": { de: "Konto der Plattform selbst. Wird hier nie verändert.", en: "The platform's own account. Never changed here." },
  "platformMailbox.open": { de: "Im Webmail öffnen", en: "Open in webmail" },
  "platformMailbox.openFailed": { de: "Das Webmail ließ sich nicht öffnen.", en: "The webmail could not be opened." },
  "platformMailbox.adopt": { de: "Übernehmen", en: "Adopt" },
  "platformMailbox.reset": { de: "Passwort neu setzen", en: "Reset password" },
  "platformMailbox.resetConfirm": { de: "Das bisherige Passwort gilt danach nicht mehr. Fortfahren?", en: "The current password stops working. Continue?" },
  "platformMailbox.delete": { de: "Löschen", en: "Delete" },
  "platformMailbox.deleteConfirm": {
    de: "{address} wird mit allen E-Mails vom Mailserver gelöscht. Das lässt sich nicht rückgängig machen.",
    en: "{address} and every email in it are deleted from the mail server. This cannot be undone.",
  },
  "platformMailbox.deleteNow": { de: "Endgültig löschen", en: "Delete permanently" },
  "platformMailbox.secret.title": { de: "Zugangsdaten für {address}", en: "Credentials for {address}" },
  "platformMailbox.secret.password": { de: "Passwort", en: "Password" },
  "platformMailbox.secret.username": { de: "Benutzername ist die Adresse selbst.", en: "The username is the address itself." },
  "platformMailbox.secret.workClient": {
    de: "Nutzbar im Webmail unter https://{webmail} oder in jeder Mail-App: IMAP {host}, Port 993, und SMTP {host}, Port 465, jeweils mit SSL/TLS.",
    en: "Use it in the webmail at https://{webmail} or in any mail app: IMAP {host}, port 993, and SMTP {host}, port 465, both with SSL/TLS.",
  },
  "platformMailbox.secret.once": {
    de: "Das Passwort wird nur dieses eine Mal angezeigt – jetzt kopieren und im Passwort-Manager ablegen.",
    en: "The password is shown this one time only – copy it now and keep it in your password manager.",
  },
  "platformMailbox.copy": { de: "Kopieren", en: "Copy" },
  "platformMailbox.copiedShort": { de: "Kopiert", en: "Copied" },
  "platformMailbox.copied": { de: "Passwort kopiert", en: "Password copied" },
  "platformMailbox.copyFailed": { de: "Kopieren nicht möglich – der Text ist markiert, bitte von Hand kopieren.", en: "Could not copy – the text is selected, copy it by hand." },
  "platformMailbox.dismissSecret": { de: "Fertig – Passwort ist gesichert", en: "Done – password is saved" },
  "platformMailbox.created": { de: "{address} ist angelegt.", en: "{address} is created." },
  "platformMailbox.adopted": { de: "{address} wird jetzt hier verwaltet.", en: "{address} is now managed here." },
  "platformMailbox.deleted": { de: "{address} ist gelöscht.", en: "{address} is deleted." },
  // ---- the business's own mail domain (#1328, epic #1322) ----
  "mailDomain.title": { de: "Eigene Mail-Domain", en: "Own mail domain" },
  "mailDomain.sub": {
    de: "Anfragen an einer Adresse Ihrer eigenen Domain empfangen statt an der von uns vergebenen.",
    en: "Receive enquiries at an address on your own domain instead of the one we issued.",
  },
  "mailDomain.claim": { de: "Domain hinzufügen", en: "Add domain" },
  "mailDomain.claimTitle": { de: "Domain hinzufügen", en: "Add a domain" },
  "mailDomain.domain": { de: "Domain", en: "Domain" },
  "mailDomain.domainHint": {
    de: "Am besten eine eigene Subdomain, zum Beispiel anfragen.ihre-firma.de. Einen Namen, der heute schon E-Mails empfängt, können wir nicht übernehmen – Ihre bisherige E-Mail bleibt so unberührt.",
    en: "Best a subdomain of your own, for example anfragen.your-company.de. We cannot take on a name that already receives mail today – your existing email stays untouched that way.",
  },
  "mailDomain.error.domainRequired": { de: "Domain fehlt", en: "Domain is required" },
  // ---- the name of the domain's address, chosen once (#1446) ----
  "mailDomain.localPart": { de: "Name der Adresse", en: "Address name" },
  "mailDomain.localPartHint": {
    de: "Der Teil vor dem @, zum Beispiel info, kontakt oder events. Die Adresse wird einmal festgelegt und lässt sich danach nicht mehr selbst ändern – für eine Änderung melden Sie sich bei uns.",
    en: "The part before the @, for example info, kontakt or events. The address is set once and cannot be changed by you afterwards – to change it, get in touch with us.",
  },
  "mailDomain.addressPreview": {
    de: "Anfragen kommen an: {address}",
    en: "Enquiries will arrive at: {address}",
  },
  "mailDomain.addressRestored": {
    de: "Diese Domain war bei Ihnen schon einmal verbunden und bekommt ihre bisherige Adresse {address} zurück. Eine einmal festgelegte Adresse ändert sich nicht – für eine andere melden Sie sich bei uns.",
    en: "This domain was connected to your business before and gets its previous address {address} back. An address, once set, does not change – for a different one, get in touch with us.",
  },
  "mailDomain.error.localPartRequired": {
    de: "Name der Adresse fehlt",
    en: "Address name is required",
  },
  "mailDomain.error.localPart.tooShort": {
    de: "Der Name der Adresse muss mindestens 3 Zeichen lang sein.",
    en: "The address name must be at least 3 characters long.",
  },
  "mailDomain.error.localPart.tooLong": {
    de: "Der Name der Adresse darf höchstens 64 Zeichen lang sein.",
    en: "The address name can be at most 64 characters long.",
  },
  "mailDomain.error.localPart.charset": {
    de: "Der Name der Adresse darf nur a–z, 0–9 und die Zeichen . - _ enthalten.",
    en: "The address name may contain only a–z, 0–9 and the characters . - _",
  },
  "mailDomain.error.localPart.edgePunctuation": {
    de: "Der Name der Adresse darf nicht mit . - _ beginnen oder enden.",
    en: "The address name may not start or end with . - _",
  },
  "mailDomain.error.localPart.adjacentPunctuation": {
    de: "Der Name der Adresse darf keine zwei Zeichen aus . - _ hintereinander enthalten.",
    en: "The address name may not contain two of . - _ in a row.",
  },
  "mailDomain.error.localPart.domainOperation": {
    de: "„{localPart}“ ist für den Betrieb der Domain reserviert – etwa für Zustell- und Missbrauchsmeldungen – und kann keine Anfragen empfangen. Bitte wählen Sie einen anderen Namen.",
    en: "“{localPart}” is reserved for operating the domain – such as delivery and abuse reports – and cannot receive enquiries. Please choose a different name.",
  },
  "mailDomain.error.addressFixed": {
    de: "{domain} war schon einmal verbunden und bekommt wieder die Adresse {address}. Eine einmal festgelegte Adresse ändert sich nicht – für eine Änderung melden Sie sich bei uns.",
    en: "{domain} was connected before and receives at {address} again. An address, once set, does not change – to change it, get in touch with us.",
  },
  // ---- one mail domain per business (#1430) ----
  "mailDomain.error.limitReached": {
    de: "Dieser Betrieb hat bereits die Domain {domain}. Pro Betrieb ist eine eigene Mail-Domain möglich – entfernen oder trennen Sie sie zuerst.",
    en: "This business already has the domain {domain}. Each business can have one mail domain – remove or disconnect it first.",
  },
  "mailDomain.limit.withdraw": {
    de: "Pro Betrieb ist eine eigene Mail-Domain möglich. Für eine andere entfernen Sie zuerst {domain}.",
    en: "Each business can have one mail domain. To use a different one, remove {domain} first.",
  },
  "mailDomain.limit.disconnect": {
    de: "Pro Betrieb ist eine eigene Mail-Domain möglich. Für eine andere trennen Sie zuerst {domain}.",
    en: "Each business can have one mail domain. To use a different one, disconnect {domain} first.",
  },
  "mailDomain.error.alreadyReceivesMail": {
    de: "{domain} empfängt bereits E-Mails ({hosts}). Mit den Einträgen für diesen Namen käme die gesamte Post zu uns – und {address} wäre die einzige Adresse, die es dann noch gibt. Nehmen Sie einen Namen, der noch keine E-Mails empfängt, zum Beispiel {suggestion}, oder entfernen Sie zuerst den MX-Eintrag, falls er nicht mehr gebraucht wird.",
    en: "{domain} already receives mail ({hosts}). With the records for this name, all of it would come to us – and {address} would be the only address left. Use a name that receives no mail yet, for example {suggestion}, or remove that MX record first if it is no longer needed.",
  },
  "mailDomain.error.mxCheckUnavailable": {
    de: "Wir konnten nicht prüfen, ob {domain} schon E-Mails empfängt. Es wurde nichts hinzugefügt – bitte versuchen Sie es gleich noch einmal.",
    en: "We could not check whether {domain} already receives mail. Nothing was added – please try again shortly.",
  },
  "mailDomain.none": { de: "Noch keine Domain hinterlegt.", en: "No domain yet." },
  "mailDomain.state.awaitingRecord": { de: "Warten auf DNS", en: "Waiting for DNS" },
  "mailDomain.state.checkUnavailable": { de: "Prüfung nicht möglich", en: "Check unavailable" },
  "mailDomain.state.finishing": { de: "Wird eingerichtet", en: "Finishing setup" },
  "mailDomain.state.receiving": { de: "Empfängt", en: "Receiving" },
  "mailDomain.hint.awaitingRecord": {
    de: "Die Einträge sind noch nicht sichtbar. Das ist normal: DNS-Änderungen brauchen oft Minuten bis Stunden.",
    en: "The records are not visible yet. That is normal: DNS changes often take minutes to hours.",
  },
  "mailDomain.hint.checkUnavailable": {
    de: "Wir konnten DNS gerade nicht abfragen. Das liegt an uns, nicht an Ihren Einträgen.",
    en: "We could not query DNS just now. That is on us, not on your records.",
  },
  "mailDomain.hint.finishing": {
    de: "Der Nachweis ist da. Wir richten die Domain ein. Bleibt es hier stehen, hilft erneutes Prüfen.",
    en: "The proof is there. We are setting the domain up. If this stays put, checking again resumes it.",
  },
  "mailDomain.alert.checkUnavailable.title": {
    de: "DNS-Abfrage fehlgeschlagen",
    en: "DNS lookup failed",
  },
  "mailDomain.alert.checkUnavailable.body": {
    de: "Bitte ändern Sie nichts an Ihren Einträgen. Versuchen Sie es später erneut; bleibt es dabei, melden Sie sich bei uns.",
    en: "Please do not change your records. Try again later; if it persists, contact us.",
  },
  // ---- also sending as the business's own address (#1329) ----
  // The pill on the sending step (#1424). A record the relay has not accepted yet is "waiting",
  // never "missing": inside the normal wait that word reads as a fault the business made.
  "mailDomain.sending.state.awaitingRecords": { de: "Wartet auf Bestätigung", en: "Awaiting confirmation" },
  "mailDomain.sending.state.dkimMissing": { de: "1 von 2 bestätigt", en: "1 of 2 confirmed" },
  "mailDomain.sending.state.returnPathMissing": { de: "1 von 2 bestätigt", en: "1 of 2 confirmed" },
  "mailDomain.sending.state.stale": { de: "Pr\u00fcfung veraltet", en: "Check out of date" },
  "mailDomain.sending.hint.notRequested": {
    de: "Antworten gehen zurzeit von Ihrer bisherigen Adresse raus. Sie k\u00f6nnen sie stattdessen von {address} senden lassen \u2013 daf\u00fcr kommen zwei weitere DNS-Eintr\u00e4ge dazu.",
    en: "Replies currently leave from your existing address. You can have them sent from {address} instead \u2013 that adds two more DNS records.",
  },
  "mailDomain.sending.hint.stale": {
    de: "Wir konnten l\u00e4nger nicht best\u00e4tigen, dass die Eintr\u00e4ge noch stehen. Solange gehen Antworten von Ihrer bisherigen Adresse raus. Bitte \u00e4ndern Sie nichts und pr\u00fcfen Sie erneut.",
    en: "We have not been able to confirm the records for a while. Until then replies leave from your existing address. Please change nothing and check again.",
  },
  "mailDomain.sending.enable": { de: "Von dieser Adresse senden", en: "Send from this address" },
  "mailDomain.sending.disable": { de: "Nicht mehr von hier senden", en: "Stop sending from here" },
  "mailDomain.sending.enabled": {
    de: "Zwei weitere Eintr\u00e4ge f\u00fcr {domain} stehen unten bereit.",
    en: "Two more records for {domain} are ready below.",
  },
  "mailDomain.sending.disabled": {
    de: "Antworten f\u00fcr {domain} gehen wieder von Ihrer bisherigen Adresse raus.",
    en: "Replies for {domain} leave from your existing address again.",
  },
  "mailDomain.records.title": { de: "Diese Einträge veröffentlichen", en: "Publish these records" },
  "mailDomain.col.type": { de: "Typ", en: "Type" },
  "mailDomain.col.name": { de: "Name", en: "Name" },
  "mailDomain.col.priority": { de: "Priorität", en: "Priority" },
  "mailDomain.col.value": { de: "Wert", en: "Value" },
  "mailDomain.copy": { de: "Kopieren", en: "Copy" },
  "mailDomain.copied": { de: "Kopiert", en: "Copied" },
  "mailDomain.check": { de: "Jetzt prüfen", en: "Check now" },
  "mailDomain.lastChecked": { de: "Zuletzt geprüft: {when}", en: "Last checked: {when}" },
  "mailDomain.neverChecked": { de: "Noch nicht geprüft.", en: "Not checked yet." },
  "mailDomain.outcome.found": { de: "Eintrag gefunden", en: "Record found" },
  "mailDomain.outcome.missing": { de: "Eintrag nicht gefunden", en: "Record not found" },
  "mailDomain.outcome.unreachable": { de: "Keine Antwort vom DNS", en: "No answer from DNS" },
  "mailDomain.lookedFor": { de: "Gesucht wurde: {record}", en: "We looked for: {record}" },
  "mailDomain.withdraw": { de: "Entfernen", en: "Remove" },
  "mailDomain.withdrawConfirm": {
    de: "{domain} entfernen? Die Einträge in Ihrer DNS-Verwaltung bleiben bestehen und können danach gelöscht werden.",
    en: "Remove {domain}? The records in your DNS panel stay and can be deleted afterwards.",
  },
  "mailDomain.withdrawNow": { de: "Entfernen", en: "Remove" },
  "mailDomain.withdrawn": { de: "{domain} wurde entfernt.", en: "{domain} was removed." },
  // ---- disconnecting a receiving domain, and what to change in DNS (#1429) ----
  "mailDomain.disconnect": { de: "Domain trennen", en: "Disconnect domain" },
  "mailDomain.disconnect.title": { de: "{domain} trennen?", en: "Disconnect {domain}?" },
  "mailDomain.disconnect.effect": {
    de: "Anfragen an {address} kommen dann nicht mehr hier an. Anfragen, die schon eingegangen sind, bleiben erhalten, und Antworten darauf gehen von Ihrer anderen Adresse raus.",
    en: "Enquiries to {address} stop arriving here. Enquiries that have already arrived stay, and replies to them leave from your other address.",
  },
  "mailDomain.disconnect.stepsTitle": {
    de: "Was Sie in Ihrer DNS-Verwaltung ändern",
    en: "What to change in your DNS panel",
  },
  "mailDomain.disconnect.step.decide": {
    de: "Legen Sie fest, wohin E-Mails an diese Adresse künftig gehen sollen.",
    en: "Decide where mail to this address should go from now on.",
  },
  "mailDomain.disconnect.step.mx": {
    de: "Ersetzen oder löschen Sie diesen MX-Eintrag, am besten vor dem Trennen. Nach dem Trennen werden E-Mails an die Adresse abgewiesen, bis der Eintrag geändert ist.",
    en: "Replace or delete this MX record, ideally before you disconnect. Once the domain is disconnected, mail to the address is rejected until the record changes.",
  },
  "mailDomain.disconnect.step.rest": {
    de: "Löschen Sie die übrigen Einträge, die Sie für uns angelegt haben.",
    en: "Delete the other records you added for us.",
  },
  "mailDomain.disconnect.step.website": {
    de: "Ändern Sie die Adresse auf Ihrer Website und in Ihren Signaturen.",
    en: "Update the address on your website and in your signatures.",
  },
  "mailDomain.disconnect.confirmLabel": {
    de: "Geben Sie zur Bestätigung {domain} ein",
    en: "Type {domain} to confirm",
  },
  "mailDomain.disconnect.mismatch": {
    de: "Das ist nicht der Domainname. Geben Sie ihn genau wie oben angezeigt ein.",
    en: "That is not the domain name. Type it exactly as shown above.",
  },
  "mailDomain.disconnect.now": { de: "Trennen", en: "Disconnect" },
  "mailDomain.disconnected": {
    de: "{domain} wurde getrennt. Ändern Sie den MX-Eintrag, falls noch nicht geschehen.",
    en: "{domain} was disconnected. Change its MX record if you have not yet.",
  },
  "mailDomain.claimed": {
    de: "{domain} wurde hinzugefügt. Jetzt die Einträge veröffentlichen.",
    en: "{domain} was added. Now publish the records.",
  },
  "mailDomain.toast.receiving": {
    de: "{domain} empfängt jetzt Anfragen.",
    en: "{domain} is now receiving enquiries.",
  },
  "mailDomain.toast.sendingConfirmed": {
    de: "Antworten für {domain} gehen jetzt von Ihrer eigenen Adresse raus.",
    en: "Replies for {domain} now leave from your own address.",
  },
  "mailDomain.toast.sendingWaiting": {
    de: "Noch nicht bestätigt. Das ist normal – der Mail-Dienst prüft von selbst weiter.",
    en: "Not confirmed yet. That is normal – the mail service keeps checking on its own.",
  },
  // ---- one card per domain as steps, with the one next action on top (#1424) ----
  "mailDomain.step.receive": { de: "Anfragen empfangen", en: "Receive enquiries" },
  "mailDomain.step.send": { de: "Von der eigenen Adresse antworten", en: "Reply from your own address" },
  "mailDomain.step.done": { de: "Fertig eingerichtet", en: "All set" },
  "mailDomain.step.optional": { de: "optional", en: "optional" },
  "mailDomain.stepStatus.done": { de: "erledigt", en: "done" },
  "mailDomain.stepStatus.current": { de: "aktueller Schritt", en: "current step" },
  "mailDomain.stepStatus.upcoming": { de: "noch offen", en: "not started yet" },
  "mailDomain.next": { de: "Als Nächstes:", en: "Next:" },
  "mailDomain.next.addRecords": {
    de: "Tragen Sie die zwei Einträge unten in Ihrer DNS-Verwaltung ein und klicken Sie danach auf „Jetzt prüfen“.",
    en: "Add the two records below in your DNS panel, then press “Check now”.",
  },
  "mailDomain.next.checkUnavailable": {
    de: "Nichts ändern. Wir konnten DNS gerade nicht abfragen – prüfen Sie später erneut.",
    en: "Change nothing. We could not query DNS just now – check again later.",
  },
  "mailDomain.next.finishing": {
    de: "Nichts zu tun. Wir richten Ihre Adresse gerade ein.",
    en: "Nothing to do. We are setting up your address.",
  },
  "mailDomain.next.enableSending": {
    de: "Optional: Antworten von {address} senden lassen statt von Ihrer bisherigen Adresse.",
    en: "Optional: have replies sent from {address} instead of your existing address.",
  },
  "mailDomain.next.publishSending": {
    de: "Tragen Sie die zwei Einträge für den Versand in Ihrer DNS-Verwaltung ein. Die Bestätigung kommt danach von selbst.",
    en: "Add the two sending records in your DNS panel. Confirmation then arrives on its own.",
  },
  "mailDomain.next.sendingStale": {
    de: "Nichts ändern. Klicken Sie auf „Versandstatus prüfen“.",
    en: "Change nothing. Press “Check sending status”.",
  },
  "mailDomain.ready": { de: "Eingerichtet", en: "Ready" },
  "mailDomain.ready.summary": {
    de: "Anfragen kommen an {address} an, und Antworten gehen von dieser Adresse raus.",
    en: "Enquiries arrive at {address}, and replies leave from it.",
  },
  "mailDomain.ready.summaryReceiveOnly": {
    de: "Anfragen kommen an {address} an.",
    en: "Enquiries arrive at {address}.",
  },
  "mailDomain.details.show": { de: "Details", en: "Details" },
  "mailDomain.details.hide": { de: "Details ausblenden", en: "Hide details" },
  "mailDomain.records.show": { de: "Einträge anzeigen", en: "Show records" },
  "mailDomain.records.hide": { de: "Einträge ausblenden", en: "Hide records" },
  "mailDomain.col.status": { de: "Status", en: "Status" },
  "mailDomain.record.confirmed": { de: "Bestätigt", en: "Confirmed" },
  "mailDomain.record.waiting": { de: "Wartet auf Bestätigung", en: "Waiting for confirmation" },
  "mailDomain.checkSending": { de: "Versandstatus prüfen", en: "Check sending status" },
  "mailDomain.justNow": { de: "gerade eben", en: "just now" },
  "mailDomain.sending.since": {
    de: "Aktiviert {when} · zuletzt geprüft {checked}",
    en: "Enabled {when} · last checked {checked}",
  },
  "mailDomain.sending.sinceUnchecked": {
    de: "Aktiviert {when} · noch nicht geprüft",
    en: "Enabled {when} · not checked yet",
  },
  // The relay confirms on its own schedule; the sentence follows how long it has been (#1424).
  "mailDomain.sending.wait.usual": {
    de: "Der Mail-Dienst bestätigt die Einträge von selbst, meist innerhalb von 10 Minuten. Sie müssen dafür nicht auf dieser Seite bleiben. Bis dahin gehen Antworten weiter von Ihrer bisherigen Adresse raus.",
    en: "The mail service confirms the records on its own, usually within 10 minutes. You do not need to stay on this page. Until then, replies keep leaving from your existing address.",
  },
  "mailDomain.sending.wait.hours": {
    de: "Das dauert länger als üblich, ist aber noch normal: Bis DNS-Änderungen beim Mail-Dienst ankommen, können einige Stunden vergehen. Bis dahin gehen Antworten weiter von Ihrer bisherigen Adresse raus – es geht nichts verloren.",
    en: "This is taking longer than usual, but is still normal: DNS changes can take up to a few hours to reach the mail service. Until then, replies keep leaving from your existing address – nothing is lost.",
  },
  "mailDomain.sending.wait.long.awaitingRecords": {
    de: "Nach über 4 Stunden ist noch keiner der beiden Einträge bestätigt. Bitte prüfen Sie in Ihrer DNS-Verwaltung, ob beide genau so stehen wie oben – oft steht ein Eintrag unter dem falschen Namen. Hilfe dazu gibt es unter „So veröffentlichen Sie die Einträge“.",
    en: "After more than 4 hours, neither record is confirmed. Please check in your DNS panel that both are exactly as shown above – often a record sits under the wrong name. “How to publish the records” below helps with that.",
  },
  "mailDomain.sending.wait.long.dkimMissing": {
    de: "Nach über 4 Stunden ist der DKIM-Eintrag noch nicht bestätigt; der Return-Path-Eintrag steht. Bitte prüfen Sie nur den DKIM-Eintrag in Ihrer DNS-Verwaltung – oft steht er unter dem falschen Namen. Hilfe dazu gibt es unter „So veröffentlichen Sie die Einträge“.",
    en: "After more than 4 hours, the DKIM record is still not confirmed; the return-path record is in place. Please check only the DKIM record in your DNS panel – often it sits under the wrong name. “How to publish the records” below helps with that.",
  },
  "mailDomain.sending.wait.long.returnPathMissing": {
    de: "Nach über 4 Stunden ist der Return-Path-Eintrag noch nicht bestätigt; der DKIM-Eintrag steht. Bitte prüfen Sie nur den Return-Path-Eintrag in Ihrer DNS-Verwaltung – oft steht er unter dem falschen Namen. Hilfe dazu gibt es unter „So veröffentlichen Sie die Einträge“.",
    en: "After more than 4 hours, the return-path record is still not confirmed; the DKIM record is in place. Please check only the return-path record in your DNS panel – often it sits under the wrong name. “How to publish the records” below helps with that.",
  },
  // ---- publishing the records: the walkthrough and the AI prompt (#1330) ----
  "mailDomain.howTo.title": {
    de: "So veröffentlichen Sie die Einträge",
    en: "How to publish the records",
  },
  "mailDomain.howTo.step1": {
    de: "Öffnen Sie die Stelle, an der die DNS-Einträge Ihrer Domain verwaltet werden, meist beim Registrar oder DNS-Anbieter. Der Bereich heißt dort DNS, Nameserver oder Zone.",
    en: "Open the place where your domain's DNS records are managed, usually at your registrar or DNS provider. That area is called DNS, Nameserver or Zone.",
  },
  "mailDomain.howTo.step2": {
    de: "Legen Sie beide Einträge oben an und übernehmen Sie Typ, Name und Wert unverändert. Nur der MX-Eintrag hat eine Priorität; beim TXT-Eintrag gibt es kein solches Feld.",
    en: "Create both records above, taking type, name and value over unchanged. Only the MX record has a priority; the TXT record has no such field.",
  },
  "mailDomain.howTo.step3": {
    de: "Speichern Sie, kommen Sie hierher zurück und prüfen Sie. Wir schauen dann nach dem TXT-Eintrag und sagen Ihnen, was wir sehen.",
    en: "Save, come back here and check. We then look for the TXT record and tell you what we see.",
  },
  "mailDomain.howTo.safe": {
    de: "Die Einträge gelten nur für {domain}. Ist das eine eigene Subdomain, bleibt die E-Mail Ihrer Hauptdomain unberührt. Steht unter diesem Namen schon ein MX-Eintrag, würde er ersetzt: dann käme die dortige Post zu uns, und Sie sollten sich vorher bei uns melden.",
    en: "The records apply only to {domain}. If that is a subdomain of your own, your main domain's email stays untouched. If an MX record already exists at this name it would be replaced, and the mail going there would come to us instead: talk to us first in that case.",
  },
  "mailDomain.howTo.waitingTitle": {
    de: "Veröffentlicht, aber es kommt nichts an?",
    en: "Published, but nothing has arrived?",
  },
  "mailDomain.howTo.waiting": {
    de: "Das ist normal. DNS-Änderungen verbreiten sich nicht sofort, oft dauert es Minuten und manchmal einige Stunden. Prüfen Sie später erneut. Bleibt es nach einigen Stunden dabei, steht der Eintrag meist unter dem falschen Namen: viele DNS-Verwaltungen hängen die Domain automatisch an das an, was Sie eintippen.",
    en: "That is normal. DNS changes do not spread instantly; often minutes, sometimes a few hours. Check again later. If it persists after a few hours, the record is usually stored under the wrong name: many panels append the domain to whatever you type.",
  },
  // The same walkthrough for the two sending records (#1424): CNAMEs, no priority, and the one
  // mistake that keeps them unconfirmed for hours — a name the panel doubled.
  "mailDomain.howTo.send.step2": {
    de: "Legen Sie beide CNAME-Einträge oben an und übernehmen Sie Name und Wert unverändert. CNAME-Einträge haben keine Priorität. Hängt Ihre DNS-Verwaltung die Domain selbst an den Namen an, lassen Sie diesen Teil beim Eintippen weg.",
    en: "Create both CNAME records above, taking name and value over unchanged. CNAME records have no priority. If your panel appends the domain to the name by itself, leave that part off when you type it.",
  },
  "mailDomain.howTo.send.step3": {
    de: "Speichern Sie. Der Mail-Dienst prüft die Einträge dann von selbst; hier sehen Sie, sobald beide bestätigt sind.",
    en: "Save. The mail service then checks the records on its own; you will see here once both are confirmed.",
  },
  "mailDomain.howTo.send.safe": {
    de: "Die beiden Einträge kommen nur dazu: Am Empfang für {domain} ändert sich nichts, und Ihre übrigen Einträge bleiben, wie sie sind.",
    en: "The two records only add to what is there: nothing changes about receiving at {domain}, and your other records stay as they are.",
  },
  "mailDomain.prompt.title": { de: "Mit einer KI veröffentlichen", en: "Publish it with an AI" },
  "mailDomain.prompt.hint": {
    de: "Jede DNS-Verwaltung sieht anders aus. Kopieren Sie diesen Text in die KI, die Sie ohnehin nutzen: Die KI fragt dann nach Ihrem Anbieter und führt Sie durch dessen Oberfläche. Der Text enthält nur die Einträge von oben, die ohnehin öffentlich im DNS stehen.",
    en: "Every DNS panel looks different. Copy this text into whichever AI you already use: it asks who your provider is and walks you through that panel. The text contains only the records above, which are public in DNS anyway.",
  },
  "mailDomain.prompt.copy": { de: "Prompt kopieren", en: "Copy the prompt" },
  "mailDomain.prompt.copied": { de: "Kopiert", en: "Copied" },
  "mailDomain.prompt.label": { de: "Prompt für eine KI", en: "Prompt for an AI" },
  "mailDomain.prompt.show": { de: "Text anzeigen", en: "Show the text" },
  "mailDomain.prompt.hide": { de: "Text ausblenden", en: "Hide the text" },
  "mailDomain.prompt.copyFailed": {
    de: "Kopieren hat nicht geklappt. Der Text steht unten, markieren und kopieren Sie ihn von Hand.",
    en: "Copying did not work. The text is below; select and copy it by hand.",
  },
  "mailDomain.prompt.intro": {
    de: "Ich möchte E-Mails für den Namen {domain} bei einem Mail-Dienst empfangen, den ich bereits nutze. Dafür muss ich zwei DNS-Einträge veröffentlichen. Bitte hilf mir dabei.",
    en: "I want to receive email for the name {domain} at a mail service I already use, and to do that I need to publish two DNS records. Please help me with it.",
  },
  "mailDomain.prompt.introSend": {
    de: "Ich möchte, dass ein Mail-Dienst, den ich bereits nutze, E-Mails im Namen von Adressen unter {domain} verschicken darf. Dafür muss ich zwei DNS-Einträge veröffentlichen. Bitte hilf mir dabei.",
    en: "I want a mail service I already use to be allowed to send email as addresses at {domain}, and to do that I need to publish two DNS records. Please help me with it.",
  },
  "mailDomain.prompt.orderHeading": {
    de: "Bitte geh in dieser Reihenfolge vor:",
    en: "Please proceed in this order:",
  },
  "mailDomain.prompt.step.askRegistrar": {
    de: "1. Frag mich zuerst, wo {domain} registriert ist oder wo das DNS dafür verwaltet wird, und warte meine Antwort ab, bevor du Schritte nennst.",
    en: "1. First ask me where {domain} is registered, or where its DNS is managed, and wait for my answer before naming any steps.",
  },
  "mailDomain.prompt.step.thenSteps": {
    de: "2. Nenne mir danach die Schritte genau für diese Oberfläche.",
    en: "2. Then give me the steps for that specific panel.",
  },
  "mailDomain.prompt.recordsHeading": {
    de: "Diese Einträge sind zu veröffentlichen. Übernimm die Werte wortwörtlich und erfinde nichts dazu; wirkt ein Wert ungewöhnlich, ist er trotzdem richtig:",
    en: "These are the records to publish. Use the values verbatim and invent nothing; if a value looks unusual, it is still correct:",
  },
  "mailDomain.prompt.record.withPriority": {
    de: "- Eintrag {n}: Typ {type}, Name {name}, Priorität {priority}, Wert {value}",
    en: "- Record {n}: type {type}, name {name}, priority {priority}, value {value}",
  },
  "mailDomain.prompt.record.plain": {
    de: "- Eintrag {n}: Typ {type}, Name {name}, Wert {value}",
    en: "- Record {n}: type {type}, name {name}, value {value}",
  },
  "mailDomain.prompt.purpose.mx": {
    de: "  Wozu: Er sagt der Welt, welcher Mailserver E-Mails für diesen Namen annimmt.",
    en: "  What it is for: it tells the world which mail server accepts mail for this name.",
  },
  "mailDomain.prompt.purpose.returnPath": {
    de: "  Zweck: Damit gilt unser Versandserver als berechtigt, E-Mails f\u00fcr diese Adresse zu verschicken, und Unzustellbarkeitsmeldungen finden zur\u00fcck.",
    en: "  Purpose: this is what makes our sending server authorised to send mail for this address, and lets bounce messages find their way back.",
  },
  "mailDomain.prompt.purpose.dkim": {
    de: "  Zweck: Damit werden die ausgehenden E-Mails signiert, damit sie beim Empf\u00e4nger nicht im Spam landen.",
    en: "  Purpose: this signs the outgoing email so it does not land in the recipient's spam folder.",
  },
  "mailDomain.prompt.purpose.txt": {
    de: "  Wozu: Er belegt gegenüber dem Mail-Dienst, dass ich diese Zone kontrolliere.",
    en: "  What it is for: it proves to the mail service that I control this zone.",
  },
  "mailDomain.prompt.limitsHeading": { de: "Wichtige Grenzen:", en: "Important limits:" },
  "mailDomain.prompt.limit.listedOnly": {
    de: "- Die Änderung besteht ausschließlich aus den oben genannten Einträgen unter dem Namen {domain}. Ändere, lösche oder verschiebe keinen anderen Eintrag der Domain und leite keinen anderen Namen um. Die bisherige E-Mail der Domain muss weiterlaufen.",
    en: "- The change consists only of the records listed above, at the name {domain}. Do not change, delete or move any other record on the domain, and do not repoint any other name. The domain's existing email must keep working.",
  },
  "mailDomain.prompt.limit.existingMx": {
    de: "- Sieh vorher nach, ob unter dem Namen des MX-Eintrags oben schon ein MX-Eintrag steht. Falls ja, würde er ersetzt und die dortige Post umgeleitet: Halt an und sag mir das, statt ihn zu überschreiben.",
    en: "- Check first whether an MX record already exists at the name of the MX record above. If one does, publishing this would replace it and redirect the mail going there: stop and tell me instead of overwriting it.",
  },
  "mailDomain.prompt.limit.nothingElse": {
    de: "- Füge keine weiteren Einträge hinzu, lösche keine und räume nichts auf.",
    en: "- Do not add any other records, do not delete any, and do not clean anything up.",
  },
  "mailDomain.prompt.limit.trailingDot": {
    de: "- Manche DNS-Verwaltungen ergänzen die Zone selbst. Lehnt die Oberfläche den Punkt am Ende ab oder hängt sie die Domain an meine Eingabe an, sag mir, wie der Name dort geschrieben werden muss.",
    en: "- Some panels add the zone themselves. If the panel rejects the trailing dot, or appends the domain to what I type, tell me how the name has to be written there.",
  },
  "mailDomain.prompt.afterHeading": {
    de: "Wenn ich sie veröffentlicht habe:",
    en: "Once I have published them:",
  },
  "mailDomain.prompt.after.verify": {
    de: "- Sag mir, wie ich die Einträge mit einer öffentlichen DNS-Abfrage selbst kontrollieren kann.",
    en: "- Tell me how to check the records myself with a public DNS lookup.",
  },
  "mailDomain.prompt.after.propagation": {
    de: "- Sag mir, dass DNS-Änderungen Zeit brauchen, dass sofort nichts zu sehen normal ist, und ab wann es tatsächlich ein Problem wäre.",
    en: "- Tell me that DNS changes take time, that seeing nothing immediately is normal, and from when it would actually be a problem.",
  },

  // ---- trusted forwarders: who may hand a customer's enquiry over (#1385) ----
  "forwarders.title": {
    de: "Weitergeleitete Anfragen",
    en: "Forwarded enquiries",
  },
  "forwarders.intro": {
    de: "Manche Kundinnen und Kunden schreiben weiter an eine persönliche Adresse. Leiten Sie so eine Mail von einer Adresse aus dieser Liste weiter, erkennt {product} die Kundin oder den Kunden dahinter — die Anfrage gehört dann ihnen, und die Antwort geht an sie, nicht an die weiterleitende Person.",
    en: "Some customers keep writing to a private address. Forward such a mail from an address on this list and {product} recognises the customer behind it — the request is theirs, and the reply goes to them rather than to whoever forwarded it.",
  },
  "forwarders.security": {
    de: "Jede Adresse hier darf {product} veranlassen, im Namen Ihres Betriebs mit Fremden zu korrespondieren. Tragen Sie nur Adressen ein, die Ihnen oder Ihrem Team gehören. Geprüft wird zusätzlich die Echtheit der Weiterleitung; fällt die Prüfung aus, bleibt die Mail eine gewöhnliche Nachricht.",
    en: "Every address here can make {product} correspond with strangers on your business's behalf. Add only addresses that belong to you or your team. The forward's authenticity is checked as well; without that check the mail stays an ordinary message.",
  },
  "forwarders.target": {
    de: "Leiten Sie die Mail an Ihre {productCompound}-Adresse weiter:",
    en: "Forward the mail to your {product} address:",
  },
  "forwarders.addressLabel": { de: "E-Mail-Adresse", en: "Email address" },
  "forwarders.labelLabel": { de: "Notiz (optional)", en: "Note (optional)" },
  "forwarders.labelPlaceholder": {
    de: "z. B. persönliche Adresse von Anna",
    en: "e.g. Anna's private address",
  },
  "forwarders.add": { de: "Adresse hinzufügen", en: "Add address" },
  "forwarders.remove": { de: "Entfernen", en: "Remove" },
  "forwarders.removeAria": { de: "{address} entfernen", en: "Remove {address}" },
  "forwarders.empty": {
    de: "Noch keine Adresse eingetragen. Weitergeleitete Mails werden wie gewöhnliche Nachrichten der weiterleitenden Person behandelt.",
    en: "No address yet. Forwarded mail is handled as an ordinary message from whoever forwarded it.",
  },
  "forwarders.added": { de: "{address} hinzugefügt", en: "{address} added" },
  "forwarders.removed": { de: "{address} entfernt", en: "{address} removed" },
  "forwarders.addFailed": { de: "Adresse konnte nicht hinzugefügt werden", en: "Could not add the address" },
  "forwarders.removeFailed": { de: "Adresse konnte nicht entfernt werden", en: "Could not remove the address" },
  "forwarders.loadFailed": { de: "Liste konnte nicht geladen werden", en: "Could not load the list" },

  "mailbox.enabledToast": { de: "Postfach aktiviert", en: "Mailbox enabled" },
  "mailbox.disabledToast": { de: "Postfach deaktiviert", en: "Mailbox disabled" },
  "mailbox.errImapHost": { de: "IMAP-Server fehlt", en: "IMAP host is required" },
  "mailbox.errImapEmail": { de: "E-Mail-Adresse fehlt", en: "Email address is required" },
  "mailbox.errImapPassword": { de: "IMAP-Passwort fehlt", en: "IMAP password is required" },
  "mailbox.errImapPort": { de: "IMAP-Port ungültig (1–65535)", en: "IMAP port is invalid (1–65535)" },
  "mailbox.errSmtpPort": { de: "SMTP-Port ungültig (1–65535)", en: "SMTP port is invalid (1–65535)" },
  // ---- master parameter boundary editing (owner) ----
  "shell.boundary": { de: "Parametergrenze", en: "Parameter boundary" },
  "boundary.title": { de: "Master-Parametergrenze", en: "Master parameter boundary" },
  "boundary.sub": {
    de: "Festlegen, welche Regelparameter Betriebe ändern dürfen. Änderungen gelten ab der jeweils nächsten Veröffentlichung.",
    en: "Decide which rule parameters businesses may change. Changes apply from each business's next publish.",
  },
  "boundary.parametersTitle": { de: "Parameter", en: "Parameters" },
  "boundary.summary": { de: "{locked} gesperrt · {overridable} überschreibbar", en: "{locked} locked · {overridable} overridable" },
  "boundary.colSubject": { de: "Gegenstand", en: "Subject" },
  "boundary.colControl": { de: "Status", en: "Status" },
  "boundary.colOverrides": { de: "Überschrieben von", en: "Overridden by" },
  "boundary.colAction": { de: "Aktion", en: "Action" },
  "boundary.locked": { de: "Gesperrt", en: "Locked" },
  "boundary.overridable": { de: "Überschreibbar", en: "Overridable" },
  "boundary.sourceOverride": { de: "Inhaber-Einstellung", en: "owner setting" },
  "boundary.lock": { de: "Sperren", en: "Lock" },
  "boundary.unlock": { de: "Freigeben", en: "Unlock" },
  "boundary.editNote": { de: "Notiz", en: "Note" },
  "boundary.lockTitle": { de: "Für Betriebe sperren?", en: "Lock for businesses?" },
  "boundary.unlockTitle": { de: "Für Betriebe freigeben?", en: "Unlock for businesses?" },
  "boundary.noteTitle": { de: "Notiz bearbeiten", en: "Edit note" },
  "boundary.noteLabel": { de: "Notiz für Betriebe (optional)", en: "Note shown to businesses (optional)" },
  "boundary.notePlaceholder": {
    de: "Warum ist dieser Gegenstand gesperrt/freigegeben?",
    en: "Why is this subject locked/unlocked?",
  },
  "boundary.lockBody": {
    de: "Betriebe können diesen Gegenstand danach nicht mehr überschreiben. Gilt ab der nächsten Veröffentlichung; bereits veröffentlichte Policy-Versionen laufen unverändert weiter.",
    en: "Businesses can no longer override this subject. Applies from the next publish; already-published policy versions keep running unchanged.",
  },
  "boundary.unlockBody": {
    de: "Betriebe dürfen diesen Gegenstand ab ihrer nächsten Veröffentlichung überschreiben.",
    en: "Businesses may override this subject from their very next publish.",
  },
  "boundary.tightenWarnTitle": { de: "Betriebe fallen aus der Grenze", en: "Businesses fall out of boundary" },
  "boundary.tightenWarnBody": {
    de: "Diese Betriebe überschreiben den Gegenstand aktuell aktiv. Ihre aktiven Policies laufen weiter, aber ihre nächste Veröffentlichung wird blockiert, bis sie die Überschreibung entfernen oder der Gegenstand wieder freigegeben wird.",
    en: "These businesses actively override this subject today. Their active policies keep running, but their next publish is blocked until they drop the override or the subject is unlocked again.",
  },
  "boundary.confirmLock": { de: "Sperren", en: "Lock" },
  "boundary.confirmUnlock": { de: "Freigeben", en: "Unlock" },
  "boundary.confirmNote": { de: "Speichern", en: "Save" },
  "boundary.saving": { de: "Speichere…", en: "Saving…" },
  "boundary.updated": { de: "Grenze aktualisiert", en: "Boundary updated" },
  "boundary.none": { de: "Keine Einträge.", en: "No entries." },
  "role.owner": { de: "Inhaber", en: "Owner" },
  "role.admin": { de: "Admin", en: "Admin" },
  "role.operator": { de: "Operator", en: "Operator" },
  "lang.label": { de: "Sprache", en: "Language" },

  // ---- business policy identity ----
  "policy.fixedCode": { de: "Fester Code-Regelsatz", en: "Fixed code ruleset" },
  "policy.activeVersion": { de: "Business-Policy v{version}", en: "Business policy v{version}" },
  "policy.version": { de: "Business-Policy v{version}", en: "Business policy v{version}" },
  "policy.availableHelp": {
    de: "Für alle Betriebe identisch und nicht bearbeitbar.",
    en: "Identical for every business and not editable.",
  },
  "policy.tenantValuesHelp": {
    de: "Regeln sind im Code festgelegt. Admins können die von der Plattform freigegebenen Werte unter Einstellungen → Regelwerte ändern.",
    en: "Rules are fixed in code. Admins can change platform-delegated values in Settings → Rule values.",
  },
  "policy.unavailable": { de: "Business-Policy nicht verfügbar", en: "Business policy unavailable" },
  "policy.unavailableHelp": {
    de: "Der feste Code-Regelsatz konnte nicht bestätigt werden.",
    en: "The fixed code ruleset could not be confirmed.",
  },
  "policy.openPolicyVersionCount": {
    de: "Festgeschriebene Policy-Versionen in offenen Anfragen: {n}.",
    en: "Distinct pinned policy versions in open requests: {n}.",
  },
  "policy.outOfBoundary": {
    de: "Die aktive Policy liegt außerhalb der Master-Grenze ({n} Regel(n)/Parameter inzwischen gesperrt) – bei der nächsten Veröffentlichung werden sie abgelehnt. Betroffen:",
    en: "The active policy is outside the master boundary ({n} rule(s)/parameter(s) locked since publish) – the next publish will reject them. Affected:",
  },
  "policy.technicalDetails": { de: "Technische Details", en: "Technical details" },
  "policy.codeRuleset": { de: "Code-Regelsatz", en: "Code ruleset" },
  "policy.parameterSet": { de: "Parameter-Komponente", en: "Parameter component" },
  "policy.runtimeSource": { de: "Laufzeitquelle", en: "Runtime source" },
  "policy.payloadHash": { de: "Policy-Payload-Hash", en: "Policy payload hash" },
  "policy.effectiveHash": { de: "Effektiver Regel-Hash", en: "Effective rules hash" },
  "policy.diagnosticCode": { de: "Diagnosecode", en: "Diagnostic code" },

  // ---- login ----
  "login.heading": { de: "Anmeldung", en: "Sign in" },
  "login.failed": { de: "Anmeldung fehlgeschlagen.", en: "Sign-in failed." },
  "login.badCreds": { de: "E-Mail oder Passwort ist nicht korrekt.", en: "Email or password is incorrect." },
  "login.email": { de: "E-Mail", en: "Email" },
  "login.password": { de: "Passwort", en: "Password" },
  "login.showPw": { de: "Passwort anzeigen", en: "Show password" },
  "login.hidePw": { de: "Passwort ausblenden", en: "Hide password" },
  "login.submitBusy": { de: "Anmeldung läuft…", en: "Signing in…" },
  "login.submit": { de: "Anmelden", en: "Sign in" },
  "login.foot": { de: "Geschützter interner Zugang", en: "Protected internal access" },
  // #1478: self-service password reset. Kept under `login.` because these screens are pre-auth too.
  "login.forgotLink": { de: "Passwort vergessen?", en: "Forgot password?" },
  "login.resetDoneTitle": { de: "Passwort geändert", en: "Password changed" },
  "login.resetDoneBody": {
    de: "Melden Sie sich jetzt mit Ihrem neuen Passwort an. Alle bisherigen Anmeldungen wurden beendet.",
    en: "Sign in with your new password. All previous sessions have been signed out.",
  },
  "login.toLogin": { de: "Zur Anmeldung", en: "Back to sign in" },
  "login.throttledTitle": { de: "Zu viele Versuche", en: "Too many attempts" },
  "login.forgot.title": { de: "Passwort vergessen", en: "Forgot your password" },
  "login.forgot.sub": {
    de: "Geben Sie die E-Mail-Adresse ein, mit der Sie sich anmelden. Wir senden Ihnen einen Link, mit dem Sie ein neues Passwort festlegen.",
    en: "Enter the email address you sign in with. We will send you a link to choose a new password.",
  },
  "login.forgot.submit": { de: "Link senden", en: "Send link" },
  "login.forgot.resend": { de: "Link erneut senden", en: "Send the link again" },
  "login.forgot.sentTitle": { de: "Bitte prüfen Sie Ihr Postfach", en: "Check your inbox" },
  "login.forgot.sentBody": {
    de: "Wenn zu dieser Adresse ein Zugang besteht, haben wir Ihnen einen Link gesendet. Er ist 60 Minuten gültig. Ist nach einigen Minuten nichts angekommen, prüfen Sie den Spam-Ordner oder fordern Sie den Link erneut an.",
    en: "If an account exists for this address, we have sent you a link. It is valid for 60 minutes. If nothing arrives within a few minutes, check your spam folder or request the link again.",
  },
  "login.forgot.failedTitle": { de: "Anfrage nicht gesendet", en: "Request not sent" },
  "login.forgot.failedBody": {
    de: "Die Anfrage konnte gerade nicht gesendet werden. Bitte versuchen Sie es in einem Moment erneut.",
    en: "The request could not be sent right now. Please try again in a moment.",
  },
  "login.forgot.invalidEmail": { de: "Bitte geben Sie eine gültige E-Mail-Adresse ein.", en: "Please enter a valid email address." },
  "login.forgot.throttledBody": {
    de: "In kurzer Zeit kamen zu viele Anfragen. Bitte warten Sie etwa {minutes} Minuten und versuchen Sie es dann erneut.",
    en: "Too many requests came in a short time. Wait about {minutes} minutes, then try again.",
  },
  "login.reset.title": { de: "Neues Passwort festlegen", en: "Choose a new password" },
  "login.reset.sub": {
    de: "Nach dem Speichern werden Sie auf allen Geräten abgemeldet und melden sich mit dem neuen Passwort wieder an.",
    en: "Once saved, you are signed out on every device and sign in again with the new password.",
  },
  "login.reset.loading": { de: "Link wird geprüft…", en: "Checking the link…" },
  "login.reset.passwordLabel": { de: "Neues Passwort", en: "New password" },
  "login.reset.passwordHint": { de: "Mindestens 10 Zeichen.", en: "At least 10 characters." },
  "login.reset.repeatLabel": { de: "Neues Passwort wiederholen", en: "Repeat new password" },
  "login.reset.mismatch": { de: "Die beiden Passwörter stimmen nicht überein.", en: "The two passwords do not match." },
  "login.reset.submit": { de: "Passwort speichern", en: "Save password" },
  "login.reset.failed": {
    de: "Das Passwort konnte gerade nicht gespeichert werden. Bitte versuchen Sie es in einem Moment erneut.",
    en: "The password could not be saved right now. Please try again in a moment.",
  },
  "login.reset.throttled": {
    de: "Zu viele Versuche in kurzer Zeit. Ihre Eingaben bleiben erhalten – bitte warten Sie einen Moment und speichern Sie dann erneut.",
    en: "Too many attempts in a short time. Your entries are kept – wait a moment, then save again.",
  },
  "login.reset.throttledBody": {
    de: "Von Ihrem Anschluss kamen in kurzer Zeit zu viele Aufrufe. Warten Sie etwa {minutes} Minuten und öffnen Sie den Link dann erneut.",
    en: "Too many requests came from your connection in a short time. Wait about {minutes} minutes, then open the link again.",
  },
  "login.resetInvalid.title": { de: "Dieser Link ist nicht mehr gültig", en: "This link is no longer valid" },
  "login.resetInvalid.body": {
    de: "Der Link wurde bereits verwendet, ist abgelaufen oder wurde durch einen neueren ersetzt.",
    en: "The link has already been used, has expired or was replaced by a newer one.",
  },
  "login.resetInvalid.requestNew": { de: "Neuen Link anfordern", en: "Request a new link" },

  // ---- denied ----
  "denied.title": { de: "Kein Zugriff", en: "No access" },
  "denied.reason.admin": {
    de: "Für den Bereich „{area}“ benötigen Sie Administratorrechte. Ihre aktuelle Rolle erlaubt diesen Zugriff nicht.",
    en: "The “{area}” area requires administrator access. Your current role does not permit this access.",
  },
  "denied.reason.owner": {
    de: "Der Bereich „{area}“ ist der Inhaberin oder dem Inhaber vorbehalten. Ihre aktuelle Rolle erlaubt diesen Zugriff nicht.",
    en: "The “{area}” area is reserved for the owner. Your current role does not permit this access.",
  },
  "denied.defaultArea": { de: "dieser Bereich", en: "this area" },
  "denied.toInbox": { de: "Zur Übersicht", en: "To the overview" },

  // ---- inbox ----
  "inbox.bulk.label": { de: "Aktionen für ausgewählte Anfragen", en: "Actions for selected requests" },
  "inbox.bulk.selectPage": { de: "Sichtbare Anfragen auswählen", en: "Select requests on this page" },
  "inbox.bulk.selectRequest": { de: "Anfrage auswählen", en: "Select request" },
  "inbox.bulk.selected": { de: "{n} ausgewählt", en: "{n} selected" },
  "inbox.bulk.clear": { de: "Auswahl aufheben", en: "Clear selection" },
  "inbox.bulk.done": { de: "Als erledigt markieren", en: "Mark Done" },
  "inbox.bulk.undoDone": { de: "Erledigt rückgängig machen", en: "Undo Done" },
  "inbox.bulk.trash": { de: "In den Papierkorb", en: "Move to trash" },
  "inbox.bulk.restore": { de: "Wiederherstellen", en: "Restore from Trash" },
  "inbox.bulk.running": { de: "Anfragen werden einzeln bearbeitet …", en: "Processing requests individually…" },
  "inbox.bulk.result": { de: "{success} erfolgreich · {failed} nicht ausgeführt oder ungeklärt", en: "{success} succeeded · {failed} refused or unconfirmed" },
  "inbox.bulk.success": { de: "Erfolgreich", en: "Succeeded" },
  "inbox.bulk.trashTitle": { de: "{n} Anfragen in den Papierkorb verschieben?", en: "Move {n} requests to trash?" },
  "inbox.bulk.trashConfirm": { de: "{n} Anfragen verschieben", en: "Move {n} requests" },
  "inbox.bulk.trashBody": { de: "Die ausgewählten Anfragen werden einzeln geprüft. Erfolgreich verschobene Anfragen können über Rückgängig wiederhergestellt werden. Nach Ablauf der bestehenden Aufbewahrungsfrist werden sie endgültig gelöscht.", en: "Each selected request is checked individually. Undo can restore successfully moved requests. They are permanently deleted after the existing retention period expires." },
  "inbox.bulk.contextChanged": { de: "Nicht ausgeführt: Die Ansicht oder der Betrieb wurde gewechselt. Prüfen Sie die Anfrage erneut.", en: "Not performed: the view or business changed. Review the request again." },
  "inbox.bulk.notAssigned": { de: "Für diese Aktion muss Ihnen die Anfrage zugewiesen sein.", en: "You must be assigned to this request for this action." },
  "inbox.bulk.noPermission": { de: "Keine Berechtigung für diese Aktion oder der Betrieb ist schreibgeschützt.", en: "This action is not permitted or the business is read-only." },
  "inbox.bulk.unavailable": { de: "Die Anfrage ist nicht mehr verfügbar.", en: "The request is no longer available." },
  "inbox.bulk.unknownOutcome": { de: "Ergebnis nicht bestätigt. Öffnen Sie die Anfrage und prüfen Sie den aktuellen Stand, bevor Sie erneut handeln.", en: "Outcome not confirmed. Open the request and check its current state before acting again." },
  // These labels name only existing configuration and reconciliation facts. They never imply
  // global health, mailbox synchronization, or a last successful mailbox poll (#986).
  "inbox.footer.aria": { de: "Betriebs- und Datenstatus", en: "Business and data status" },
  "inbox.footer.ingest": { de: "Postfacheingang", en: "Inbox ingestion" },
  "inbox.footer.aiExtraction": { de: "KI-Extraktion", en: "AI extraction" },
  "inbox.footer.ruleset": { de: "Fester Regelsatz", en: "Fixed ruleset" },
  "inbox.footer.state.on": { de: "Freigeschaltet", en: "Enabled" },
  "inbox.footer.state.off": { de: "Ausgeschaltet", en: "Disabled" },
  "inbox.footer.state.unknown": { de: "Unbekannt", en: "Unknown" },
  "inbox.sub": { de: "Eingehende Catering-Anfragen prüfen und bearbeiten", en: "Review and process incoming catering requests" },
  "inbox.subConversations": { de: "Kundenkonversationen prüfen und den Vorgang mit der höchsten Priorität öffnen", en: "Review customer conversations and open the highest-priority request" },
  "inbox.reviewNeededCount": { de: "{n} Prüfung nötig", en: "{n} need review" },
  "inbox.statusAll": { de: "Status: alle", en: "Status: all" },
  "inbox.colNumber": { de: "Nr.", en: "No." },
  "inbox.colFrom": { de: "Absender", en: "Sender" },
  "inbox.colSubject": { de: "Betreff", en: "Subject" },
  "inbox.colStatus": { de: "Status", en: "Status" },
  "inbox.colAssignee": { de: "Zugewiesen an", en: "Assignee" },
  "inbox.colAge": { de: "Alter", en: "Age" },
  "inbox.colCustomer": { de: "Kunde", en: "Customer" },
  "inbox.colCustomerEvent": { de: "Kunde / Vorgang", en: "Customer / request" },
  "inbox.colLatestActivity": { de: "Letzte Aktivität", en: "Latest activity" },
  "inbox.colPurgeAt": { de: "Endgültig gelöscht am", en: "Deleted for good on" },
  "inbox.trashPurgeAt": { de: "Wird am {date} endgültig gelöscht", en: "Deleted for good on {date}" },
  "inbox.eventSummaryAria": { de: "Eckdaten der Veranstaltung", en: "Event details" },
  "inbox.colLastMessage": { de: "Letzte Nachricht", en: "Last message" },
  "inbox.colActiveRequests": { de: "Aktive Vorgänge", en: "Active requests" },
  "inbox.viewLabel": { de: "Ansicht", en: "View" },
  "inbox.viewTable": { de: "Tabelle", en: "Table" },
  "inbox.viewConversations": { de: "Konversationen", en: "Conversations" },
  "inbox.viewBoard": { de: "Brett", en: "Board" },
  "inbox.viewRequests": { de: "Vorgänge", en: "Requests" },
  "inbox.laneEmpty": { de: "Keine Anfragen", en: "No requests" },
  "inbox.laneEmptyConversations": { de: "Keine Konversationen", en: "No conversations" },
  "inbox.unassigned": { de: "Nicht zugewiesen", en: "Unassigned" },
  "inbox.assignee.changeFor": { de: "Zuweisung für {subject} ändern", en: "Change assignment for {subject}" },
  "inbox.assignee.failed": { de: "Zuweisung fehlgeschlagen. Erneut versuchen oder Berechtigung und Verfügbarkeit prüfen.", en: "Assignment failed. Retry or check access and availability." },
  "inbox.assigneeMore": { de: "+{n} weitere", en: "+{n} more" },
  "inbox.unknownSender": { de: "Unbekannter Absender", en: "Unknown sender" },
  "inbox.newReply": { de: "Neue Antwort", en: "New reply" },
  "inbox.attention.new_reply": { de: "Neue Kundenantwort", en: "New customer reply" },
  "inbox.attention.human_review": { de: "Manuelle Prüfung", en: "Manual review" },
  "inbox.attention.decision_recompute": { de: "Entscheidung veraltet", en: "Decision outdated" },
  "inbox.attention.stale_draft": { de: "Entwurf veraltet", en: "Draft outdated" },
  "inbox.attention.draft_rejected": { de: "Entwurf abgelehnt", en: "Draft rejected" },
  "inbox.unopened": { de: "Neu", en: "New" },
  "inbox.attention.draft_send": { de: "Freigegebener Entwurf", en: "Approved draft" },
  "inbox.attention.draft_review": { de: "Entwurf prüfen", en: "Review draft" },
  "inbox.attention.new_request": { de: "Neue Anfrage", en: "New request" },
  "inbox.segAll": { de: "Alle", en: "All" },
  "inbox.segReviewOnly": { de: "Nur Prüfung nötig", en: "Review needed only" },
  "inbox.segUnassigned": { de: "Nicht zugewiesen", en: "Unassigned" },
  "inbox.taskFiltersAria": { de: "Arbeitsbereich filtern", en: "Filter work queue" },
  "inbox.task.new": { de: "Neu", en: "New" },
  "inbox.task.review": { de: "Zu bearbeiten", en: "To process" },
  "inbox.task.waiting": { de: "Warten auf Antwort", en: "Waiting for reply" },
  "inbox.task.all": { de: "Alle", en: "All" },
  "inbox.task.archived": { de: "Archiv", en: "Archive" },
  "inbox.task.trash": { de: "Papierkorb", en: "Trash" },
  "inbox.previewMore.new": { de: "Weitere {n} neue Vorgänge anzeigen", en: "Show {n} more new requests" },
  "inbox.previewMore.review": { de: "Weitere {n} zu bearbeitende Vorgänge anzeigen", en: "Show {n} more requests to process" },
  "inbox.previewMore.waiting": { de: "Weitere {n} wartende Vorgänge anzeigen", en: "Show {n} more waiting requests" },
  "inbox.assigneeAll": { de: "Zugewiesen an: alle", en: "Assignee: all" },
  "inbox.filterAssigneeAria": { de: "Nach Zuweisung filtern", en: "Filter by assignee" },
  "inbox.filterStatusAria": { de: "Status filtern", en: "Filter by status" },
  "inbox.filterDateFromAria": { de: "Zeitraum von", en: "Period from" },
  "inbox.filterDateToAria": { de: "Zeitraum bis", en: "Period to" },
  "inbox.period.title": { de: "Zeitraum", en: "Period" },
  "inbox.period.presetsAria": { de: "Vordefinierte Zeiträume", en: "Preset periods" },
  "inbox.period.all": { de: "Alle", en: "All" },
  "inbox.period.today": { de: "Heute", en: "Today" },
  "inbox.period.week": { de: "Diese Woche", en: "This week" },
  "inbox.period.month": { de: "Dieser Monat", en: "This month" },
  "inbox.period.custom": { de: "Eigener Zeitraum", en: "Custom range" },
  "inbox.filterSortAria": { de: "Sortierung", en: "Sort order" },
  "inbox.sort.activity_desc": { de: "Neueste zuerst", en: "Newest first" },
  "inbox.sort.activity_asc": { de: "Älteste zuerst", en: "Oldest first" },
  "inbox.clearDateRange": { de: "Zeitraum aufheben", en: "Clear period" },
  "inbox.dateRange.reversed": {
    de: "Das Bis-Datum liegt vor dem Von-Datum.",
    en: "The end date is before the start date.",
  },
  "inbox.dateRange.tooWide": {
    de: "Der Zeitraum darf höchstens 366 Tage umfassen.",
    en: "The period may cover at most 366 days.",
  },
  "inbox.dateRange.outOfCalendar": {
    de: "Das Datum liegt außerhalb des Kalenders (2000–2100).",
    en: "The date is outside the supported calendar (2000–2100).",
  },
  "inbox.filterAria": { de: "Filter", en: "Filter" },
  "inbox.searchPlaceholder": { de: "Kunde, Nachricht oder Referenz…", en: "Customer, message or reference…" },
  "inbox.searchPlaceholderWide": { de: "Betreff, Kunde, Vorgang oder Inhalt suchen…", en: "Search subject, customer, request or content…" },
  "inbox.searchAria": { de: "Suche", en: "Search" },
  "inbox.loadErrorTitle": { de: "Daten konnten nicht geladen werden", en: "Data could not be loaded" },
  "inbox.countOfTotal": { de: "{n} von {total} Anfragen", en: "{n} of {total} requests" },
  "inbox.emptyTitle": { de: "Keine Anfragen", en: "No requests" },
  "inbox.emptyMessage": { de: "Es liegen keine Anfragen vor, die den Filtern entsprechen.", en: "There are no requests matching the current filters." },
  "inbox.loadError": { de: "Die Liste konnte nicht geladen werden.", en: "The list could not be loaded." },
  "inbox.openAria": { de: "Vorgang öffnen: {subject} von {from}", en: "Open request: {subject} from {from}" },
  "inbox.openConversationStatusAria": { de: "Status: {status}", en: "Status: {status}" },
  "inbox.emptyConversationTitle": { de: "Keine Konversationen", en: "No conversations" },
  "inbox.emptyConversationMessage": { de: "Es gibt keine Konversationen, die den aktuellen Filtern entsprechen.", en: "There are no conversations matching the current filters." },
  "inbox.emptyArchiveTitle": { de: "Kein Archiv", en: "Nothing archived" },
  "inbox.emptyArchiveMessage": { de: "Abgeschlossene Vorgänge erscheinen hier, sobald sie archiviert sind.", en: "Completed requests appear here once they are archived." },
  "inbox.archiveHint": { de: "Abgeschlossen und archiviert — nur zum Nachlesen.", en: "Completed and archived — for reference only." },
  "inbox.emptyTrashTitle": { de: "Der Papierkorb ist leer", en: "The trash is empty" },
  "inbox.emptyTrashMessage": {
    de: "Vorgänge, die Sie in den Papierkorb verschieben, erscheinen hier.",
    en: "Requests you move to the trash appear here.",
  },
  "inbox.noMessagePreview": { de: "Keine Nachrichtenvorschau", en: "No message preview" },
  "inbox.activeRequestCount.one": { de: "{n} aktiver Vorgang", en: "{n} active request" },
  "inbox.activeRequestCount.other": { de: "{n} aktive Vorgänge", en: "{n} active requests" },
  "inbox.paginationAria": { de: "Seitennavigation der Vorgänge", en: "Request pagination" },
  "inbox.pageOf": { de: "Seite {page} von {total}", en: "Page {page} of {total}" },
  "inbox.previousPage": { de: "Zurück", en: "Previous" },
  "inbox.nextPage": { de: "Weiter", en: "Next" },
  "inbox.draftSent": { de: "Beantwortet", en: "Answered" },
  "inbox.draftToReview": { de: "Entwurf zu prüfen", en: "Draft to review" },
  "inbox.draftApproved": { de: "Entwurf freigegeben", en: "Draft approved" },
  "inbox.draftStale": { de: "Entwurf veraltet", en: "Draft stale" },
  "inbox.draftRejected": { de: "Entwurf abgelehnt/veraltet", en: "Draft rejected/stale" },
  "inbox.draftNone": { de: "Kein Entwurf", en: "No draft" },
  "inbox.draftGenerating": { de: "Entwurf wird generiert", en: "Generating draft" },
  "inbox.assignmentNoticeTitle": { de: "Neu zugewiesen", en: "New assignment" },
  "inbox.assignmentNoticeBody": { de: "{subject} von {from}", en: "{subject} from {from}" },
  "inbox.assignmentNoticeMore": { de: "{n} weitere Vorgänge wurden Ihnen zugewiesen.", en: "{n} more requests were assigned to you." },

  // ---- toast notifications (#536) ----
  "toast.region": { de: "Benachrichtigungen", en: "Notifications" },
  "toast.newRequestTitle": { de: "Neue Anfrage", en: "New request" },
  "toast.newReplyTitle": { de: "Neue Antwort", en: "New reply" },
  "toast.arrivalBody": { de: "{subject} von {from}", en: "{subject} from {from}" },
  "toast.arrivalsTitle": { de: "{n} neue Nachrichten", en: "{n} new messages" },
  "toast.arrivalsBody": { de: "In der Übersicht ansehen.", en: "Review them in the overview." },
  "toast.openRequest": { de: "Öffnen", en: "Open" },
  "toast.openInbox": { de: "Übersicht öffnen", en: "Open overview" },
  "toast.undo": { de: "Rückgängig", en: "Undo" },
  "toast.undoneAssignment": { de: "Zuweisung zurückgenommen", en: "Assignment reverted" },

  // ---- UNKNOWN delivery reconciliation ----
  "delivery.queue.title": { de: "Unklare Zustellungen prüfen", en: "Review unclear deliveries" },
  "delivery.queue.subtitle": { de: "Manueller Abgleich erforderlich", en: "Manual reconciliation required" },
  "delivery.queue.count": { de: "{n} offen", en: "{n} unresolved" },
  "delivery.queue.loading": { de: "Unklare Zustellungen werden geladen…", en: "Loading unclear deliveries…" },
  "delivery.queue.empty": { de: "Keine unklaren Zustellungen offen.", en: "No unclear deliveries are unresolved." },
  "delivery.queue.verifyInstructions": {
    de: "Prüfen Sie die Zustellung in der maßgeblichen externen Mailbox oder im Provider-Protokoll. Das System versendet niemals automatisch erneut.",
    en: "Verify delivery in the authoritative external mailbox or provider log. The system never resends automatically.",
  },
  "delivery.action.delivered": { de: "Als zugestellt markieren", en: "Mark delivered" },
  "delivery.action.notDelivered": { de: "Als nicht zugestellt markieren", en: "Mark not delivered" },
  "delivery.action.confirmDelivered": { de: "Zustellung bestätigen", en: "Confirm delivered" },
  "delivery.action.confirmNotDelivered": { de: "Nichtzustellung bestätigen", en: "Confirm not delivered" },
  "delivery.confirm.deliveredTitle": { de: "E-Mail wurde zugestellt?", en: "Was the email delivered?" },
  "delivery.confirm.notDeliveredTitle": { de: "E-Mail wurde nicht zugestellt?", en: "Was the email not delivered?" },
  "delivery.confirm.attempt": { de: "Versuch: {id}", en: "Attempt: {id}" },
  "delivery.confirm.deliveredBody": {
    de: "Der Versandversuch wird als gesendet abgeschlossen. Der Vorgang wird nur dann als beantwortet markiert, wenn seit diesem Entwurf keine neuere Arbeit entstanden ist.",
    en: "The send attempt will be finalized as sent. The request is marked answered only when no newer work has superseded this draft.",
  },
  "delivery.confirm.notDeliveredBody": {
    de: "Der Versuch wird als vor dem Versand fehlgeschlagen markiert. Es wird jetzt keine E-Mail gesendet; ein späterer Versuch muss erneut den normalen Freigabe- und Versandweg durchlaufen.",
    en: "The attempt will be marked failed before submission. No email is sent now; any later attempt must pass the normal approval and send flow again.",
  },
  "delivery.recipient": { de: "Empfänger", en: "Recipient" },
  "delivery.attemptNumber": { de: "Versuch", en: "Attempt" },
  "delivery.attemptedAt": { de: "Begonnen", en: "Started" },
  "delivery.completedAt": { de: "SMTP-Versuch beendet", en: "SMTP attempt finished" },
  "delivery.errorCode": { de: "Fehlercode", en: "Error code" },
  "delivery.smtpMessageId": { de: "SMTP Message-ID", en: "SMTP Message-ID" },
  "delivery.providerMessageId": { de: "Provider Message-ID", en: "Provider Message-ID" },
  "delivery.attemptId": { de: "Attempt-ID", en: "Attempt ID" },
  "delivery.draftId": { de: "Draft-ID", en: "Draft ID" },
  "delivery.auditIdentity": { de: "Attempt-ID: {attemptId} · Draft-ID: {draftId}", en: "Attempt ID: {attemptId} · Draft ID: {draftId}" },
  "delivery.messageIdMissing": { de: "Nicht verfügbar", en: "Not available" },
  "delivery.currentDraft": { de: "Aktueller Entwurf", en: "Current draft" },
  "delivery.historicalDraft": { de: "Älterer Entwurf", en: "Historical draft" },
  "delivery.openRequest": { de: "Vorgang öffnen", en: "Open request" },
  "delivery.error.load": { de: "Unklare Zustellungen konnten nicht geladen werden.", en: "Unclear deliveries could not be loaded." },
  "delivery.error.stale": { de: "Dieser Versuch wurde bereits abgeglichen. Die aktuellen Daten wurden neu geladen.", en: "This attempt was already reconciled. The authoritative state was reloaded." },
  "delivery.error.resolve": { de: "Der Zustellstatus konnte nicht gespeichert werden.", en: "The delivery status could not be saved." },
  "delivery.success.delivered": { de: "Zustellung als erfolgreich abgeglichen.", en: "Delivery reconciled as delivered." },
  "delivery.success.notDelivered": { de: "Nichtzustellung bestätigt. Es wurde keine E-Mail gesendet.", en: "Non-delivery confirmed. No email was sent." },

  // ---- bounces and complaints reported after the send (#711) ----
  "deliveryFailure.hardBounce.title": {
    de: "Diese E-Mail hat den Empfänger nicht erreicht",
    en: "This email did not reach the recipient",
  },
  "deliveryFailure.hardBounce.body": {
    de: "Der Mailserver des Empfängers hat die Nachricht dauerhaft abgelehnt. Die Adresse funktioniert nicht — bitte klären Sie eine andere Kontaktmöglichkeit ab. Es wird nichts automatisch erneut gesendet.",
    en: "The recipient's mail server refused the message permanently. The address does not work — please establish another way to reach them. Nothing is resent automatically.",
  },
  "deliveryFailure.softBounce.title": {
    de: "Zustellung mehrfach vorübergehend fehlgeschlagen",
    en: "Delivery failed temporarily several times",
  },
  "deliveryFailure.softBounce.body": {
    de: "Die Zustellung ist {count}-mal vorübergehend fehlgeschlagen (z. B. volles Postfach). Ab {threshold} Versuchen weisen wir darauf hin, weil die Adresse sich wie eine defekte verhält. Es wird nichts automatisch erneut gesendet.",
    en: "Delivery failed temporarily {count} times (a full mailbox, for example). We flag it from {threshold} onward because the address is behaving like a broken one. Nothing is resent automatically.",
  },
  "deliveryFailure.complaint.title": {
    de: "Empfänger hat diese E-Mail als Spam gemeldet",
    en: "The recipient marked this email as spam",
  },
  "deliveryFailure.complaint.body": {
    de: "Bitte schreiben Sie diesen Empfänger nicht erneut an, ohne das zu klären. Beschwerden verschlechtern die Zustellbarkeit für alle Vorgänge über diese Absenderadresse.",
    en: "Please do not write to this recipient again without clarifying it first. Complaints degrade deliverability for every request sent from this address.",
  },
  "deliveryFailure.recipient": { de: "Empfänger", en: "Recipient" },
  "deliveryFailure.occurredAt": { de: "Gemeldet", en: "Reported" },
  "deliveryFailure.diagnostic": { de: "Meldung des Mailservers", en: "Message from the mail server" },

  // ---- settings ----
  "settings.title": { de: "Einstellungen", en: "Settings" },
  "settings.sub": { de: "Anwendungseinstellungen verwalten", en: "Manage application settings" },
  "settings.ruleReferenceAction": { de: "Regelreferenz öffnen", en: "Open rule reference" },
  "settings.ruleset": { de: "Regelsatz", en: "Ruleset" },
  "settings.featureFlags": { de: "Funktionen", en: "Features" },
  "settings.flagsHint": {
    de: "Zeigt den Deploy-Status; beim E-Mail-Versand zusätzlich den effektiven Status und Admin-Schalter.",
    en: "Shows deployment status; email sending additionally shows its effective status and Admin switch.",
  },
  "settings.featureEffectiveStatus": { de: "Effektiver Status", en: "Effective status" },
  "settings.featureDeployStatus": { de: "Deploy-Status", en: "Deployment status" },
  "settings.featureAuthority": { de: "Gesteuert durch", en: "Controlled by" },
  "settings.featureDeployAuthority": { de: "Deploy-Umgebung", en: "Deployment environment" },
  "settings.followupAuthority": {
    de: "Env-Kill-Switch, Admin-Schalter und Betriebseinstellung",
    en: "Environment kill switch, Admin switch, and business setting",
  },
  "settings.sourceDetails": { de: "Quellen und Steuerung", en: "Sources and controls" },
  "settings.businessPolicy": { de: "Business-Policy", en: "Business policy" },
  // #1989: the business's own logo in the console header.
  "settings.logo.title": { de: "Logo Ihres Betriebs", en: "Your business logo" },
  "settings.logo.hint": {
    de: "Ihr Logo steht oben links in der Kopfzeile – auf jeder Seite, für alle, die in diesem Betrieb angemeldet sind. Ohne eigenes Logo steht dort das Zeichen von {product}.",
    en: "Your logo sits at the top left of the header – on every page, for everyone signed in to this business. Without one, the {product} mark is shown there.",
  },
  "settings.logo.statusOwn": { de: "Eigenes Logo", en: "Own logo" },
  "settings.logo.statusDefault": { de: "Standard", en: "Default" },
  "settings.logo.preview": { de: "So sieht die Kopfzeile aus", en: "How the header looks" },
  "settings.logo.requirements": {
    de: "PNG oder JPEG, bis 512 KiB und 4096 × 4096 Pixel. Das Logo steht ohne Rahmen direkt auf der dunklen Kopfzeile – am besten eignet sich eine Fassung für dunklen Hintergrund oder eine mit eigenem Hintergrund. E-Mails behalten das Logo aus der Signatur.",
    en: "PNG or JPEG, up to 512 KiB and 4096 × 4096 pixels. The logo sits directly on the dark header without a frame, so a version made for a dark background, or one with its own background, works best. Emails keep the logo from the signature.",
  },
  "settings.logo.upload": { de: "Logo hochladen", en: "Upload logo" },
  "settings.logo.replace": { de: "Logo ersetzen", en: "Replace logo" },
  "settings.logo.remove": { de: "Logo entfernen", en: "Remove logo" },
  "settings.logo.saved": { de: "Logo gespeichert. Es steht jetzt in der Kopfzeile.", en: "Logo saved. It is now in the header." },
  "settings.logo.removed": { de: "Logo entfernt. Die Kopfzeile zeigt wieder {product}.", en: "Logo removed. The header shows {product} again." },
  "settings.logo.invalid": {
    de: "Diese Datei kann nicht als Logo verwendet werden. Wählen Sie eine PNG- oder JPEG-Datei bis 512 KiB und 4096 × 4096 Pixel.",
    en: "This file cannot be used as a logo. Choose a PNG or JPEG file up to 512 KiB and 4096 × 4096 pixels.",
  },
  "settings.logo.unreadableTitle": { de: "Das Logo kann nicht angezeigt werden", en: "The logo cannot be displayed" },
  "settings.logo.unreadable": {
    de: "Die Datei ist gespeichert, lässt sich aber nicht darstellen. Die Kopfzeile zeigt deshalb weiter {product}. Ersetzen Sie das Logo durch eine andere Datei.",
    en: "The file is stored but cannot be drawn, so the header keeps showing {product}. Replace the logo with another file.",
  },
  "settings.logo.failed": {
    de: "Das Logo konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
    en: "The logo could not be saved. Please try again.",
  },
  "settings.signature": { de: "E-Mail-Signatur", en: "Email signature" },
  "settings.signatureHint": {
    de: "Wird unter neuen Antworten eingefügt. Bereits erstellte Entwürfe behalten ihre Signatur.",
    en: "Added below new replies. Existing drafts keep their signature.",
  },
  // #1320: one editor, not a text box beside an HTML box. Both stored fields still exist — the
  // editor produces them together — but nobody is asked to write HTML by hand any more.
  "settings.signatureContent": { de: "Signatur", en: "Signature" },
  "settings.signatureEmptyHelp": { de: "Leer speichern entfernt die eigene Signatur.", en: "Save an empty signature to remove the custom block." },
  "settings.signatureTableActions": { de: "Tabelle", en: "Table" },
  "settings.signatureFormatting": { de: "Signatur formatieren", en: "Signature formatting" },
  "settings.signatureFontSize": { de: "Schriftgröße", en: "Font size" },
  "settings.signatureColor": { de: "Farbe", en: "Colour" },
  "settings.signatureAlignment": { de: "Ausrichtung", en: "Alignment" },
  "settings.signatureAlign.left": { de: "Links", en: "Left" },
  "settings.signatureAlign.center": { de: "Zentriert", en: "Centre" },
  "settings.signatureAlign.right": { de: "Rechts", en: "Right" },
  "settings.signatureAlign.justify": { de: "Blocksatz", en: "Justify" },
  "settings.signatureTable": { de: "Tabelle einfügen", en: "Insert table" },
  "settings.signatureAddRow": { de: "Zeile hinzufügen", en: "Add row" },
  "settings.signatureAddColumn": { de: "Spalte hinzufügen", en: "Add column" },
  "settings.signatureRemoveTable": { de: "Tabelle entfernen", en: "Remove table" },
  "settings.signatureRule": { de: "Trennlinie", en: "Horizontal rule" },
  "settings.signatureLogo": { de: "Logo einfügen", en: "Insert logo" },
  "settings.signatureLogoHelp": { de: "PNG oder JPEG, bis 512 KiB und 4096 × 4096 Pixel. Das Logo wird mit der E-Mail versendet.", en: "PNG or JPEG, up to 512 KiB and 4096 × 4096 pixels. The logo travels with the email." },
  "settings.signatureLogoError": { de: "Das Logo konnte nicht geladen werden. Wählen Sie eine PNG- oder JPEG-Datei bis 512 KiB und 4096 × 4096 Pixel.", en: "The logo could not be uploaded. Choose a PNG or JPEG up to 512 KiB and 4096 × 4096 pixels." },
  "settings.signatureLogoUnavailable": { de: "Das Logo dieser Signatur ist nicht verfügbar. Die E-Mail kann erst nach erfolgreicher Prüfung versendet werden.", en: "This signature's logo is unavailable. The email can only be sent after it passes verification." },
  // #1452: shown while a logo is selected, beside the corner handles that do the same thing.
  "settings.signatureLogoActions": { de: "Logo", en: "Logo" },
  "settings.signatureLogoWidth": { de: "Logobreite in Pixeln", en: "Logo width in pixels" },
  "settings.signatureSource": { de: "HTML-Quelltext", en: "HTML source" },
  "settings.signatureSourceHelp": { de: "Der Quelltext unterstützt dieselben Formate wie der Editor. Nicht unterstützte Elemente werden beim Übernehmen entfernt.", en: "Source supports the same formatting as the editor. Unsupported elements are removed when applied." },
  "settings.signatureApply": { de: "Übernehmen", en: "Apply" },
  "settings.signatureContentError": { de: "Die Signatur ist zu groß oder zu tief verschachtelt. Kürzen Sie den Inhalt, bevor Sie speichern.", en: "The signature is too large or too deeply nested. Shorten it before saving." },
  "settings.signaturePlaceholder": {
    de: "Firmierung, Anschrift und Pflichtangaben eingeben…",
    en: "Company name, address and legal details…",
  },
  "settings.signatureSave": { de: "Signatur speichern", en: "Save signature" },
  "settings.signatureSaved": { de: "Signatur gespeichert", en: "Signature saved" },
  "settings.signatureChangedElsewhereTitle": { de: "Signatur wurde anderswo geändert", en: "Signature changed elsewhere" },
  "settings.signatureChangedElsewhereBody": { de: "Ihre Eingaben bleiben erhalten. Speichern überschreibt die andere Änderung.", en: "Your input is kept. Saving overwrites the other change." },
  "settings.signatureSourceTenant": { de: "Eigene Signatur", en: "Custom signature" },
  "settings.signatureSourceDefault": { de: "Standard-Signatur", en: "Built-in default" },
  "settings.signatureSourceNone": { de: "Keine Signatur", en: "No signature" },
  "settings.followupAdminToggle": { de: "Admin-Schalter", en: "Admin switch" },
  "settings.followupAdminToggleAria": {
    de: "E-Mail-Versand – Admin-Schalter",
    en: "Email sending – Admin switch",
  },
  "settings.followupEnvLocked": { de: "Env gesperrt", en: "Env locked" },
  "settings.followupEnabled": { de: "E-Mail-Versand aktiviert", en: "Email sending enabled" },
  "settings.followupDisabled": { de: "E-Mail-Versand deaktiviert", en: "Email sending disabled" },
  "settings.followupSaveFailed": { de: "Versand-Schalter konnte nicht gespeichert werden.", en: "Could not save the sending switch." },

  // ---- account ----
  "account.title": { de: "Konto", en: "Account" },
  "account.sub": { de: "Profil und Anmeldedaten verwalten", en: "Manage your profile and sign-in details" },
  "account.sectionsAria": { de: "Konto-Bereiche", en: "Account sections" },
  "account.profile": { de: "Profil", en: "Profile" },
  "account.displayName": { de: "Anzeigename", en: "Display name" },
  "account.email": { de: "E-Mail", en: "Email" },
  "account.saveProfile": { de: "Profil speichern", en: "Save profile" },
  "account.profileSaved": { de: "Profil gespeichert", en: "Profile saved" },
  "account.emailUnavailable": {
    de: "Diese E-Mail kann nicht verwendet werden.",
    en: "This email cannot be used.",
  },
  "account.notifications": { de: "Benachrichtigungen", en: "Notifications" },
  "account.notificationSounds": { de: "Töne für neue E-Mails", en: "Inbound notification sounds" },
  "account.notificationSoundsHint": {
    de: "Spielt einen kurzen Ton für jede neu eingegangene Kunden-E-Mail ab.",
    en: "Plays a short sound for every newly received customer email.",
  },
  "account.password": { de: "Passwort", en: "Password" },
  "account.passwordHint": {
    de: "Nach der Änderung bleiben Sie hier angemeldet; alle anderen Sitzungen werden beendet.",
    en: "After the change, this session stays signed in and every other session is ended.",
  },
  "account.currentPassword": { de: "Aktuelles Passwort", en: "Current password" },
  "account.newPassword": { de: "Neues Passwort", en: "New password" },
  "account.confirmPassword": { de: "Neues Passwort bestätigen", en: "Confirm new password" },
  "account.passwordRequirement": { de: "Mindestens 10 Zeichen", en: "At least 10 characters" },
  "account.savePassword": { de: "Passwort ändern", en: "Change password" },
  "account.passwordSaved": { de: "Passwort geändert", en: "Password changed" },
  "account.passwordMismatch": { de: "Die neuen Passwörter stimmen nicht überein.", en: "The new passwords do not match." },
  "account.currentPasswordInvalid": { de: "Das aktuelle Passwort ist falsch.", en: "The current password is incorrect." },

  // ---- staff ----
  "staff.title": { de: "Personal", en: "Staff" },
  "staff.peopleTab": { de: "Mitarbeitende", en: "People" },
  "staff.sub": { de: "Operatoren und Zugriffsrollen verwalten", en: "Manage operators and access roles" },
  "staff.operators": { de: "Operatoren", en: "Operators" },
  "staff.colName": { de: "Name", en: "Name" },
  "staff.colEmail": { de: "E-Mail", en: "Email" },
  "staff.colRole": { de: "Rolle", en: "Role" },
  "staff.colCreated": { de: "Erstellt", en: "Created" },
  "staff.colAction": { de: "Aktion", en: "Action" },
  "staff.noOperators": { de: "Keine Operatoren.", en: "No operators." },
  "staff.createOperator": { de: "Teammitglied anlegen", en: "Add team member" },
  "staff.create": { de: "Anlegen", en: "Create" },
  "staff.passwordCol": { de: "Passwort", en: "Password" },
  "staff.deleteCol": { de: "Löschen", en: "Delete" },
  "staff.changePw": { de: "Passwort ändern", en: "Change password" },
  "staff.newPw": { de: "Neues Passwort", en: "New password" },
  "staff.savePw": { de: "Passwort speichern", en: "Save password" },
  "staff.saving": { de: "Speichert…", en: "Saving…" },
  "staff.deleteOperator": { de: "Operator löschen", en: "Delete operator" },
  "staff.deleting": { de: "Löscht…", en: "Deleting…" },
  "staff.deleteConfirm": { de: "Dieser Operator wird gelöscht:", en: "This operator will be deleted:" },
  "staff.deleteIrreversible": { de: "Diese Aktion kann nicht rückgängig gemacht werden.", en: "This action cannot be undone." },
  "staff.operatorCreated": { de: "Operator angelegt", en: "Operator created" },
  "staff.roleChanged": { de: "Rolle geändert", en: "Role changed" },
  "staff.pwChanged": { de: "Passwort geändert", en: "Password changed" },
  "staff.deleted": { de: "Gelöscht", en: "Deleted" },

  // ---- work teams (#802) ----
  "teams.title": { de: "Teams", en: "Teams" },
  "teams.count.one": { de: "{n} Team", en: "{n} team" },
  "teams.count.other": { de: "{n} Teams", en: "{n} teams" },
  "teams.none": { de: "Noch keine Teams.", en: "No teams yet." },
  "teams.namePlaceholder": { de: "Teamname", en: "Team name" },
  "teams.create": { de: "Team anlegen", en: "Create team" },
  "teams.created": { de: "Team angelegt", en: "Team created" },
  "teams.memberCount": { de: "{n} Mitglieder", en: "{n} members" },
  "teams.archived": { de: "Archiviert", en: "Archived" },
  "teams.open": { de: "Öffnen", en: "Open" },
  "teams.back": { de: "Zurück zu Teams", en: "Back to teams" },
  "teams.rename": { de: "Umbenennen", en: "Rename" },
  "teams.saveName": { de: "Speichern", en: "Save" },
  "teams.actions": { de: "Team verwalten", en: "Team actions" },
  "teams.memberActions": { de: "Aktionen für {name}", en: "Actions for {name}" },
  "teams.addMemberTitle": { de: "Mitglied hinzufügen", en: "Add member" },
  "teams.searchPeople": { de: "Name oder E-Mail suchen", en: "Search name or email" },
  "teams.searchEmpty": { de: "Keine passenden Mitarbeitenden. Versuchen Sie einen anderen Namen oder eine andere E-Mail.", en: "No matching people. Try another name or email." },
  "teams.selectedPerson": { de: "Ausgewählt: {name}", en: "Selected: {name}" },
  "teams.removeFromTeam": { de: "Aus Team entfernen", en: "Remove from team" },
  "teams.archiveConfirm": { de: "„{name}“ archivieren?", en: "Archive “{name}”?" },
  "teams.renamed": { de: "Team umbenannt", en: "Team renamed" },
  "teams.members": { de: "Mitglieder", en: "Members" },
  "teams.noMembers": { de: "Noch niemand in diesem Team.", en: "Nobody in this team yet." },
  "teams.addMember": { de: "Hinzufügen", en: "Add" },
  "teams.memberAdded": { de: "Mitglied hinzugefügt", en: "Member added" },
  "teams.removeMember": { de: "Entfernen", en: "Remove" },
  "teams.memberRemoved": { de: "Mitglied entfernt", en: "Member removed" },
  "teams.choosePerson": { de: "Person wählen…", en: "Choose a person…" },
  "teams.allAdded": { de: "Alle Mitarbeitenden sind bereits im Team.", en: "Everyone is already in this team." },
  "teams.archive": { de: "Team archivieren", en: "Archive team" },
  "teams.archiveDone": { de: "Team archiviert", en: "Team archived" },
  "teams.archiveHint": {
    de: "Ein archiviertes Team wird nicht gelöscht: es bleibt auffindbar und wird nur nicht mehr für neue Arbeit angeboten.",
    en: "An archived team is not deleted: it stays resolvable and is simply no longer offered for new work.",
  },
  "teams.restore": { de: "Wiederherstellen", en: "Restore" },
  "teams.restored": { de: "Team wiederhergestellt", en: "Team restored" },
  "teams.archivedNotice": {
    de: "Dieses Team ist archiviert. Zum Ändern zuerst wiederherstellen.",
    en: "This team is archived. Restore it before making changes.",
  },

  // ---- getting started (#1286) ----
  // The first thing a new business reads. "What happens now" comes before "what to do next"
  // deliberately: the first question about software that answers your customers is not what to
  // click, it is what it will send without you.
  "shell.gettingStarted": { de: "Erste Schritte", en: "Getting started" },
  "gettingStarted.title": { de: "Erste Schritte", en: "Getting started" },
  "gettingStarted.sub": {
    de: "Was {product} für Sie tut — und was für die Einrichtung noch fehlt.",
    en: "What {product} does for you — and what is still missing from your setup.",
  },
  "gettingStarted.how.title": { de: "So läuft es ab", en: "How it works" },
  "gettingStarted.how.receive.title": { de: "E-Mail kommt an", en: "Mail arrives" },
  "gettingStarted.how.receive.body": {
    de: "Anfragen an Ihre Adresse landen hier in der Übersicht. Newsletter, automatische Antworten und Unzustellbarkeitsmeldungen werden aussortiert.",
    en: "Enquiries sent to your address land in the overview here. Newsletters, automatic replies and bounce notices are set aside.",
  },
  "gettingStarted.how.read.title": { de: "Die Anfrage wird gelesen", en: "The enquiry is read" },
  "gettingStarted.how.read.body": {
    de: "Datum, Personenzahl, Ort, Wünsche und Auflagen werden aus dem Text entnommen — jeweils mit der Stelle, an der es steht.",
    en: "Date, headcount, location, preferences and constraints are taken from the text — each with the passage it came from.",
  },
  "gettingStarted.how.review.title": { de: "Ein Entwurf entsteht", en: "A draft is prepared" },
  "gettingStarted.how.review.body": {
    de: "Preise, Mengen und Bedingungen rechnet {product} nach festen Regeln und den Angaben Ihres Betriebs aus. Der Antworttext wird daraus auf Deutsch formuliert.",
    en: "Prices, quantities and conditions are worked out from fixed rules and your business details. The German reply is then written from that.",
  },
  "gettingStarted.how.send.title": { de: "Sie geben frei", en: "You approve" },
  "gettingStarted.how.send.body": {
    de: "Sie lesen den Entwurf, ändern ihn, wenn Sie möchten, und senden ihn ab.",
    en: "You read the draft, change it if you want to, and send it.",
  },
  "gettingStarted.how.guaranteeTitle": { de: "Nichts geht ohne Ihre Freigabe raus", en: "Nothing goes out without your approval" },
  "gettingStarted.how.guaranteeBody": {
    de: "Keine E-Mail verlässt {product}, ohne dass ein Mensch sie freigegeben hat. Es gibt keine Einstellung, die das abschaltet.",
    en: "No email leaves {product} without a person approving it. There is no setting that turns this off.",
  },
  "gettingStarted.mailWarningTitle": { de: "Dieser Betrieb kann noch keine E-Mails empfangen", en: "This business cannot receive email yet" },
  "gettingStarted.mailWarningBody": {
    de: "Für diesen Betrieb ist keine aktive Adresse eingerichtet, deshalb kommen zurzeit keine Kundenanfragen an. Einrichten können wir das nur von unserer Seite — bitte melden Sie sich bei uns.",
    en: "No live address is set up for this business, so no customer enquiries are arriving. Only we can set that up — please get in touch with us.",
  },
  "gettingStarted.next.title": { de: "Das fehlt noch", en: "What to do next" },
  "gettingStarted.next.unknown": {
    de: "Der Einrichtungsstand lässt sich gerade nicht abrufen. Bitte laden Sie die Seite später neu.",
    en: "The setup state cannot be read right now. Please reload the page later.",
  },
  "gettingStarted.state.done": { de: "Erledigt", en: "Done" },
  "gettingStarted.state.open": { de: "Offen", en: "Open" },
  "gettingStarted.task.signature.title": { de: "E-Mail-Signatur hinterlegen", en: "Set your email signature" },
  "gettingStarted.task.signature.body": {
    de: "Die Signatur steht unter jeder Antwort an Ihre Kundschaft — mit Firmierung und Pflichtangaben. Ohne sie gehen Antworten ohne diesen Abschluss raus.",
    en: "Your signature closes every reply to a customer — company details and the legally required information. Without it, replies go out without that block.",
  },
  "gettingStarted.task.signature.action": { de: "Zur Signatur", en: "Open signature" },
  "gettingStarted.task.colleagues.title": { de: "Kolleginnen und Kollegen einladen", en: "Invite colleagues" },
  "gettingStarted.task.colleagues.body": {
    de: "Bisher hat nur eine Person Zugang. Mit einem zweiten Zugang bleiben Anfragen auch dann beantwortet, wenn Sie im Urlaub oder krank sind.",
    en: "Only one person has access so far. A second account keeps enquiries answered while you are on holiday or ill.",
  },
  "gettingStarted.task.colleagues.action": { de: "Zum Personal", en: "Open staff" },

  "flag.ai_enabled": { de: "KI-Extraktion & -Formulierung", en: "AI extraction & composition" },
  "flag.followup_send_enabled": { de: "E-Mail-Versand", en: "Email sending" },
  "flag.bp_export_enabled": { de: "BankettProfi-Export", en: "BankettProfi export" },
  "flag.external_lookup_enabled": { de: "Externe Ermittlung (Adresse/Datum)", en: "External lookup (address/date)" },

};
